<template>
    <div class="user__global__alert global__alert">
        <b-modal v-model="confirmDeleteAlert" type="warn" title="Confirm Deletion" @ok="deleteAlert(deleteAlertId)"
            ok-title="Yes, Delete">
            <p>Are you sure you want to delete this alert?</p>
        </b-modal>
        <b-modal size="lg" hide-footer id="userGlobalAlertDetail" class="modal-global-alert-detail">
            <template slot='modal-title'>
                {{ alertTitle }}
                <p class="notification-sender">
                    sent by {{ alertSender }} @ {{ getLocalAlertTime(alertTime) }}
                </p>
            </template>
            <span v-html="alertDetail"></span>
        </b-modal>

        <b-modal centered hide-footer id="viewTitleModal" title="Enter View Title">
            <ViewTitleModal @setActiveView="setActiveView" ref="refViewTitleModal" />
        </b-modal>
        <b-modal centered hide-footer id="viewTitleUpdateModal" title="Enter View Title">
            <ViewTitleModal :title="viewBtnLabel" @setActiveView="setActiveView" :viewId="activeView" ref="refViewTitleModal" />
        </b-modal>

        <b-modal centered id="headerViewSelectModal" hide-footer title="Views" @hidden="viewSelectModalHidden">
            <div id="header-view-select-modal" class="saved-views">
                <div class="view-select-title-header">
                    <h4>Views</h4>
                    <b-button class="d-block" variant="theme" title="Close View Popup" size="sm"
                        @click="closeViewSelectModal"><i class="fas fa-times"></i></b-button>
                </div>
                <div class="view-select-body">
                    <a class="dropdown-item clear-view" @click="handleResetFilter(); $bvModal.hide('headerViewSelectModal');"
                        href="#" v-show="activeView != '-1'">
                        Clear View
                        <span class="float-right">
                            <i class="fas fa-cross text-primary"></i>
                        </span>
                    </a>
                    <a class="dropdown-item update-view" @click="modalUpdateView" href="#"
                        v-show="viewModalShowUpdateView">
                        Update View
                        <span class="float-right">
                            <i class="far fa-edit text-primary"></i>
                        </span>
                    </a>
                    <a class="dropdown-item save-view" @click="modalSaveView" href="#"
                        v-show="viewModalShowCreateView">
                        Save View
                        <span class="float-right">
                            <i class="fas fa-plus-circle text-primary"></i>
                        </span>
                    </a>

                    <div class="new-view-title-area" v-if="showNewViewTitleArea">
                        <div class="row">
                            <div class="col-md-12">
                                <h5>Save View</h5>
                            </div>
                        </div>
                        <ViewTitleModal @setActiveView="setActiveView" :hasCancelButton="true"
                            @cancelEdit="showNewViewTitleArea = false" />
                    </div>
                    <div class="update-view-title-area" v-if="showUpdateViewTitleArea">
                        <div class="row">
                            <div class="col-md-12">
                                <h5>Update View</h5>
                            </div>
                        </div>
                        <ViewTitleModal :title="viewBtnLabel" @setActiveView="setActiveView" :viewId="activeView"
                            :hasCancelButton="true" @cancelEdit="showUpdateViewTitleArea = false" />
                    </div>

                    <div class="views__scroll" ref="views__scroll"
                        v-if="!showNewViewTitleArea && !showUpdateViewTitleArea">
                        <div :class="{'scroll__view__btns': !viewModalShowCreateView && !viewModalShowUpdateView}">
                            <!-- Preset Views -->
                            <a class="dropdown-item" :class="{active : activeView == userView.id}"
                                @click="loadViewFromModal(userView)" :key="'notificationPresetView'+index+1*Math.random()"
                                v-for="(userView, index) in presetViewsNotification" href="#">
                                <div class="preset-icon-wrap">
                                </div>
                                <span class="save-title">{{ userView.title }}</span>
                            </a>

                            <!-- User Views -->
                            <a class="dropdown-item" :class="{active : activeView == userView.id}"
                                @click="loadViewFromModal(userView)" :key="'notificationView'+index+1*Math.random()"
                                v-for="(userView, index) in notificationViews" href="#">
                                <div class="remove-icon-wrap">
                                    <span class="remove-icon" @click.stop="removeView(userView.id)">
                                        <i class="fas fa-trash"></i>
                                    </span>
                                </div>
                                <span class="save-title">{{ userView.title }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <HeaderControls ref="headerControls" :namespace="namespace" :availableFilters="availableFilters"
            @filter-change="handleFilterChange" />
        <div class="fixed-top-bar-padding">
            <div class="container-fluid">
                <div class="deliverable-header">
                    <h2>
                        <div>
                            <div class="media-call-icon pointer-default">
                                <img width="30px" src="@/csmworkflow/img/bell-module.svg" />
                            </div>
                            {{ headerText }}
                        </div>

                        <span class="d-inline-block saved-views-area pt-15" :class="[activeView != '-1' ? 'saved-view-active' : '']">
                            <b-button v-if="typeof userAlerts.data != 'undefined' && userAlerts.data.length > 0"
                                variant="theme" class="btn btn-theme" @click.stop="makeAllFilteredAlertsRead">
                                {{ markAllButtonLabel }}
                                <div role="status" v-show="runningTask"
                                    class="ml-2 spinner-border spinner-border-sm text-primary"><span
                                        class="sr-only">Marking...</span></div>
                            </b-button>

                            <!-- Desktop Views dropdown -->
                            <div class="btn-group ml-2 add-new__global_search sorting saved-views d-none d-md-inline-flex">
                                <button
                                    class="btn btn-theme header-filter-btns dropdown-toggle"
                                    type="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    @click="updatePerfectScroll"
                                >
                                    <span class="mr-3 view__label truncate-text">{{ viewBtnLabel }}</span>
                                    <i v-if="activeView == '-1'" class="fas fa-fw fa-eye text-primary float-right"></i>
                                    <i v-else v-b-tooltip.hover="{customClass: 'save__view__tooltip'}" title="Clear View"
                                        @click.stop="handleResetFilter" class="fas fa-fw fa-eye text-primary float-right"></i>
                                </button>
                                <div class="dropdown-menu viewmenu-dropdown">
                                    <div>
                                        <a class="dropdown-item update-view" @click="updateView" href="#" v-show="viewModalShowUpdateView">
                                            Update View
                                            <span class="float-right">
                                                <i class="far fa-edit text-primary"></i>
                                            </span>
                                        </a>
                                        <a class="dropdown-item save-view" @click="saveView" href="#">
                                            Save View
                                            <span class="float-right">
                                                <i class="fas fa-plus-circle text-primary"></i>
                                            </span>
                                        </a>
                                            <perfect-scrollbar class="views__scroll" ref="views__scroll">
                                                <div>
                                                    <!-- Preset Views -->
                                                    <a class="dropdown-item"
                                                        :class="{active : activeView == userView.id}"
                                                        @click="loadView(userView)" :key="'notificationPresetViewDD'+index+1*Math.random()"
                                                        v-for="(userView, index) in presetViewsNotification" href="#">
                                                        <div class="preset-icon-wrap"></div>
                                                        <span class="save-title">{{ userView.title }}</span>
                                                    </a>

                                                    <a class="dropdown-item" :class="{active : activeView == userView.id}"
                                                        @click="loadView(userView)" :key="'notificationViewDD'+index+1*Math.random()"
                                                        v-for="(userView, index) in notificationViews" href="#">
                                                        <div class="remove-icon-wrap">
                                                        <span class="remove-icon" @click.stop="removeView(userView.id)">
                                                            <i class="fas fa-trash"></i>
                                                        </span>
                                                    </div>
                                                    <span class="save-title">{{ userView.title }}</span>
                                                </a>
                                            </div>
                                        </perfect-scrollbar>
                                    </div>
                                </div>
                            </div>

                            <!-- Mobile Views button -->
                            <b-button v-b-modal.headerViewSelectModal variant="theme" class="btn btn-theme ml-2 d-md-none">
                                {{ viewBtnLabel }}
                                <i class="fas text-primary fa-eye fa-fw"></i>
                            </b-button>
                        </span>
                    </h2>
                </div>
            </div>

            <div class="container-fluid">
                <div class="global-alerts-status">
                    <span v-if="typeof userAlerts.data != 'undefined' && userAlerts.data.length == 0 && getUnreadGlobalAlerts().length == 0">
                        <h2>You have no notifications.</h2>
                    </span>

                    <!-- Important Notifications (unread global alerts) -->
                    <div v-if="getUnreadGlobalAlerts().length" class="global-alerts-top mb-4">
                        <!-- When grouping by project/deliverable, match the group block style (no expander) -->
                        <div v-if="currentFilters.group_by === 'deliverable' || currentFilters.group_by === 'project'"
                            class="mb-4 notification-group-block important-notification-block">
                            <div class="d-flex flex-row dbox-wrapper">
                                <div class="w-100 dbox-left-side">
                                    <div class="top-row">
                                        <div class="data-items group-title">
                                            <h3 class="group-header-title mb-0" style="cursor: default;">
                                                Important Notifications
                                            </h3>
                                        </div>
                                        <div class="data-items w-100">
                                            <div class="notification-preview"
                                                :id="`notification-alert-${getUnreadGlobalAlerts()[0].id}`">
                                                <div class="notification-icon-wrapper cursor-pointer"
                                                    v-b-tooltip.hover
                                                    title="Mark as read"
                                                    @click.stop="markAlertReadOnly(getUnreadGlobalAlerts()[0])">
                                                    <img src="@/csmworkflow/img/bell-regular.svg" class="notification-icon" />
                                                </div>
                                                <p class="details cursor-pointer" @click.stop="setAlert(getUnreadGlobalAlerts()[0])">
                                                    <span class="alert__name cursor-pointer fw-bold">{{ getUnreadGlobalAlerts()[0].title }}</span>
                                                    <br>
                                                    <span class="notification-sender">
                                                        <span class="fw-bold">{{ getUnreadGlobalAlerts()[0].sender }} @ {{ getLocalAlertTime(getUnreadGlobalAlerts()[0].created_at) }}</span>
                                                    </span>
                                                    <br>
                                                    <span class="note-message" v-html="processMessage(getUnreadGlobalAlerts()[0].message)"></span>
                                                </p>
                                                <div class="ml-auto pr-2">
                                                    <b-button size="sm" variant="theme" class="btn btn-theme"
                                                        @click.stop="markSingleAlertRead(getUnreadGlobalAlerts()[0])">
                                                        Mark as Read
                                                    </b-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <ul v-if="getUnreadGlobalAlerts().length > 1" class="list-unstyled notification-list-single-column">
                                        <li v-for="alert in getUnreadGlobalAlerts().slice(1)"
                                            :key="'important-group-' + alert.id"
                                            :id="`notification-alert-${alert.id}`"
                                            class="group-alert-item notification-single-row unread-notification">
                                            <div class="placeholder-n"></div>
                                            <div class="notification-info-wrapper">
                                                <div class="notification-icon-wrapper cursor-pointer"
                                                    v-b-tooltip.hover
                                                    title="Mark as read"
                                                    @click.stop="markAlertReadOnly(alert)">
                                                    <img src="@/csmworkflow/img/bell-regular.svg" class="notification-icon" />
                                                </div>
                                                <p class="details cursor-pointer" @click.stop="setAlert(alert)">
                                                    <span class="alert__name cursor-pointer fw-bold">{{ alert.title }}</span>
                                                    <br>
                                                    <span class="notification-sender">
                                                        <span class="fw-bold">{{ alert.sender }} @ {{ getLocalAlertTime(alert.created_at) }}</span>
                                                    </span>
                                                    <br>
                                                    <span class="note-message" v-html="processMessage(alert.message)"></span>
                                                </p>
                                                <div class="ml-auto pr-2">
                                                    <b-button size="sm" variant="theme" class="btn btn-theme"
                                                        @click.stop="markSingleAlertRead(alert)">
                                                        Mark as Read
                                                    </b-button>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <!-- When grouping by date/none/global_alert/etc, use the normal list style -->
                        <div v-else>
                            <div class="d-flex justify-content-between align-items-center mb-3 group-header-row">
                                <h4 class="group-header mb-0">Important Notifications</h4>
                            </div>
                            <div class="global-alerts-section">
                                <ul class="list-unstyled no-grouping-list mb-0">
                                    <li v-for="alert in getUnreadGlobalAlerts()"
                                        :key="'important-top-' + alert.id"
                                        :id="`notification-alert-${alert.id}`"
                                        class="no-group-alert-item notification-single-row unread-notification">
                                        <div class="notification-info-wrapper">
                                            <div class="notification-icon-wrapper cursor-pointer"
                                                v-b-tooltip.hover
                                                title="Mark as read"
                                                @click.stop="markAlertReadOnly(alert)">
                                                <img src="@/csmworkflow/img/bell-regular.svg" class="notification-icon" />
                                            </div>
                                            <p class="details cursor-pointer"
                                                v-b-tooltip.hover
                                                title="View detail"
                                                @click.stop="setAlert(alert)">
                                                <span class="alert__name cursor-pointer fw-bold">{{ alert.title }}</span>
                                                <br>
                                                <span class="notification-sender">
                                                    <span class="fw-bold">{{ alert.sender }} @ {{ getLocalAlertTime(alert.created_at) }}</span>
                                                </span>
                                                <br>
                                                <span class="note-message" v-html="processMessage(alert.message)"></span>
                                            </p>
                                            <div class="ml-auto pr-2">
                                                <b-button size="sm" variant="theme" class="btn btn-theme"
                                                    @click.stop="markSingleAlertRead(alert)">
                                                    Mark as Read
                                                </b-button>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- Grouped display by Date/Deliverable/Project -->
                    <div v-if="currentFilters.group_by && currentFilters.group_by !== 'none'"
                        class="alert-item clearfix">
                        <div v-for="(group, groupKey) in visibleGroupedAlerts"
                            :key="'group-' + groupKey"
                            class="mb-4"
                            :class="['notification-group-collapsible-' + groupKey, { 'notification-group-block': currentFilters.group_by !== 'date' }]">
                            <!-- Project/Deliverable grouping - collapsible with header and button -->
                            <div v-if="currentFilters.group_by !== 'date'" class="d-flex flex-row dbox-wrapper">
                                <div class="w-100 dbox-left-side">
                                    <div class="top-row">
                                        <div class="data-items group-title">
                                            <h3 class="group-header-title mb-0"
                                                v-b-tooltip.hover
                                                :title="(currentFilters.group_by === 'deliverable' && getGroupMeta(groupKey) && (getGroupMeta(groupKey).deleted || getGroupMeta(groupKey).project_deleted)) ? 'Deliverable/Project deleted' : 'Open'"
                                                :style="{ cursor: (currentFilters.group_by === 'deliverable' && !canOpenDeliverableGroup(groupKey)) ? 'default' : 'pointer' }"
                                                @click.stop="(currentFilters.group_by === 'deliverable' && !canOpenDeliverableGroup(groupKey)) ? null : goToDetailPage(groupKey)">
                                                {{ (getGroupMeta(groupKey) && getGroupMeta(groupKey).title) || groupKey }}
                                                <small v-if="currentFilters.group_by === 'deliverable' && getGroupMeta(groupKey) && getGroupMeta(groupKey).project_title" class="d-block text-muted" style="font-size: 0.75rem; font-weight: normal;">
                                                    {{ getGroupMeta(groupKey).project_title }}
                                                </small>
                                            </h3>
                                        </div>
                                        <div class="data-items">
                                            <!-- Show the first (latest) notification -->
                                            <div v-if="currentFilters.group_by === 'project'" class="read-notification">
                                                <div class="notification-info-wrapper fw-bold">
                                                    <p class="details mb-0">
                                                        <span>{{ getProjectGroupDeliverableCount(groupKey) }}</span> deliverables
                                                        <span class="text-muted px-1">•</span>
                                                        <span>{{ getGroupUnreadTotal(groupKey) }}</span> unread notifications
                                                    </p>
                                                </div>
                                            </div>
                                            <div v-else-if="getGroupAlerts(groupKey).length > 0" class="notification-preview"
                                                :id="`notification-alert-${getGroupAlerts(groupKey)[0].id}`"
                                                :class="getGroupAlerts(groupKey)[0].status == 0 ? '' : 'read-notification'">
                                                <div class="notification-icon-wrapper cursor-pointer"
                                                    v-b-tooltip.hover
                                                            :title="getGroupAlerts(groupKey)[0].status == 0 ? 'Mark as read' : 'Read'"
                                                    @click.stop="markAlertReadOnly(getGroupAlerts(groupKey)[0], groupKey, { isTopRow: true })">
                                                    <img v-if="currentFilters.group_by === 'deliverable' || (currentFilters.group_by === 'project' && getGroupAlerts(groupKey)[0].deliverable_group_id)"
                                                        :src="getDeliverableIconSrc(getGroupAlerts(groupKey)[0].status)" class="notification-icon" />
                                                    <img v-else-if="currentFilters.group_by === 'global_alert'" src="@/csmworkflow/img/bell-regular.svg" class="notification-icon" />
                                                    <i v-else-if="currentFilters.group_by === 'project'" :class="['fas', 'fa-folder', 'fa-fw', 'notification-icon-fa']" :style="{ color: getProjectIconColor(getGroupAlerts(groupKey)[0].status) }"></i>
                                                </div>
                                                <p class="details cursor-pointer"
                                                    v-b-tooltip.hover
                                                    title="View detail"
                                                    @click.stop="setAlert(getGroupAlerts(groupKey)[0], groupKey, { isTopRow: true })">
                                                    <span class="alert__name cursor-pointer fw-bold">{{ getGroupAlerts(groupKey)[0].title
                                                        }}</span>
                                                    <br>
                                                    <span class="notification-sender">
                                                        <span class="fw-bold">{{ getGroupAlerts(groupKey)[0].sender }} @ {{
                                                            getLocalAlertTime(getGroupAlerts(groupKey)[0].created_at) }}</span>
                                                    </span>
                                                    <br>
                                                    <span class="note-message"
                                                        v-html="processMessage(getGroupAlerts(groupKey)[0].message)"></span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="data-items ml-auto">
                                            <b-button class="btn btn-theme" variant="theme"
                                                @click.stop="makeGroupAlertsRead(groupKey)" v-if="showGroupMarkButton(groupKey)">
                                                Mark All as Read
                                            </b-button>
                                        </div>
                                    </div>
                                    <b-collapse :id="'notification-group-collapse-' + groupKey">
                                        <!-- Group By Project: show deliverable sub-groups under the project -->
                                        <div v-if="currentFilters.group_by === 'project'">
                                            <ul v-if="getProjectSectionAlerts(groupKey).length"
                                                class="list-unstyled notification-list-single-column project-section-list">
                                                <li
                                                    :key="'project-section-header-' + groupKey"
                                                    class="group-alert-item notification-single-row project-section-header"
                                                    :class="projectSectionHasUnread(groupKey) ? 'unread-notification' : 'read-notification'">
                                                    <div class="placeholder-n"></div>
                                                    <div class="notification-info-wrapper">
                                                        <div class="notification-icon-wrapper cursor-pointer"
                                                            v-b-tooltip.hover
                                                            :title="getMarkAllProjectSectionTooltip(groupKey)"
                                                            :class="projectSectionHasUnread(groupKey) ? 'cursor-pointer' : 'pointer-default'"
                                                            @click.stop="projectSectionHasUnread(groupKey) ? markAllProjectLevelNotifsRead(groupKey) : null">
                                                            <i :class="['fas', 'fa-folder', 'fa-fw', 'notification-icon-fa']"
                                                                :style="{ color: getProjectIconColor(projectSectionHasUnread(groupKey) ? 0 : 1) }"></i>
                                                        </div>
                                                        <span v-if="projectSectionHasUnread(groupKey)" class="alert-status">
                                                            <i class="fas fa-circle text-primary"
                                                                v-b-tooltip.hover
                                                                title="Unread"></i>
                                                        </span>
                                                        <p class="details cursor-pointer"
                                                            v-b-tooltip.hover
                                                            title="Open project"
                                                            @click.stop="goToDetailPage(groupKey)">
                                                            <span class="alert__name cursor-pointer">
                                                                {{ (getGroupMeta(groupKey) && getGroupMeta(groupKey).title) || groupKey }}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </li>
                                                <li :key="'project-alert-' + alert.id"
                                                    :id="`notification-alert-${alert.id}`"
                                                    v-for="alert in getProjectSectionVisibleAlerts(groupKey)"
                                                    class="group-alert-item notification-single-row"
                                                    :class="alert.status == 0 ? 'unread-notification' : 'read-notification'">
                                                    <div class="placeholder-n"></div>
                                                    <div class="notification-info-wrapper">
                                                        <div class="notification-icon-wrapper cursor-pointer"
                                                            v-b-tooltip.hover
                                                            :title="alert.status == 0 ? 'Mark as read' : 'Read'"
                                                            @click.stop="markAlertReadOnly(alert, groupKey)">
                                                            <i :class="['fas', 'fa-folder', 'fa-fw', 'notification-icon-fa']"
                                                                :style="{ color: getProjectIconColor(alert.status) }"></i>
                                                        </div>
                                                        <span v-if="alert.status == 0" class="alert-status">
                                                            <i class="fas fa-circle"
                                                                :class="alert.status == 0 ? 'text-primary' : 'text-primary'"
                                                                v-b-tooltip.hover
                                                                :title="alert.status == 0 ? 'Unread' : 'Read'"></i>
                                                        </span>
                                                        <p class="details cursor-pointer"
                                                            v-b-tooltip.hover
                                                            title="View detail"
                                                            @click.stop="setAlert(alert, groupKey)">
                                                            <span class="alert__name cursor-pointer fw-bold">{{ alert.title }}</span>
                                                            <br>
                                                            <span class="notification-sender">
                                                                <span class="fw-bold">{{ alert.sender }} @ {{ getLocalAlertTime(alert.created_at) }}</span>
                                                            </span>
                                                            <br>
                                                            <span class="note-message" v-html="processMessage(alert.message)"></span>
                                                        </p>
                                                    </div>
                                                </li>
                                             </ul>
                                            <!-- Load more project-level notifications (keep above deliverable sub-groups) -->
                                            <div class="text-center py-3"
                                                v-if="getProjectSectionTotal(groupKey) > 5 && projectSectionHasMoreToShow(groupKey)">
                                                <b-button
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    class="load-more-btn"
                                                    @click.stop="loadMoreProjectSection(groupKey)"
                                                    :disabled="groupLoadingMore[groupKey]">
                                                    <span v-if="groupLoadingMore[groupKey]">
                                                        Loading...
                                                    </span>
                                                    <span v-else>
                                                        Load More
                                                    </span>
                                                </b-button>
                                            </div>
                                            <div v-for="subGroup in getProjectSubgroups(groupKey)"
                                                :key="'project-subgroup-' + subGroup.key"
                                                class="d-flex flex-row dbox-wrapper project-subgroup-wrapper">
                                                <div class="w-100 dbox-left-side">
                                                    <div class="top-row">
                                                        <div class="data-items group-title"></div>
                                                        <div class="data-items">
                                                            <div :class="['notification-preview', 'deliverable-subgroup-preview', subGroup.unread === 0 ? 'read-notification' : '']">
                                                               <div
                                                                   class="notification-icon-wrapper  cursor-pointer"
                                                                   v-b-tooltip.hover
                                                                   :title="getMarkAllDeliverableSubgroupTooltip(subGroup)"
                                                                    @click.stop="markAllDeliverableSubgroupNotifsRead(groupKey, subGroup.deliverableId, subGroup.unread)"
                                                                >
                                                                    <img :src="getDeliverableSubgroupHeaderIcon(subGroup)"
                                                                        class="deliverable-subgroup-title-icon" />
                                                                </div>
                                                                <p :class="['details deliverable-subgroup-title', subGroup.deleted ? 'text-muted' : 'cursor-pointer']"
                                                                    v-b-tooltip.hover
                                                                    :title="subGroup.deleted ? 'Deliverable deleted' : 'Open deliverable'"
                                                                    @click.stop="!subGroup.deleted && openDeliverableFromProjectSubgroup(groupKey, subGroup.deliverableId)">
                                                                    <span class="fw-bold">{{ subGroup.title }}</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <b-collapse :id="'notification-group-collapse-' + subGroup.key" visible>
                                                        <ul class="list-unstyled notification-list-single-column">
                                                            <li :key="'alert-' + subGroup.key + '-' + index"
                                                                :id="`notification-alert-${alert.id}`"
                                                                v-for="(alert, index) in subGroup.alerts"
                                                                class="group-alert-item notification-single-row"
                                                                :class="alert.status == 0 ? 'unread-notification' : 'read-notification'">
                                                                <div class="placeholder-n"></div>
                                                                <div class="notification-info-wrapper">
                                                                    <div class="notification-icon-wrapper cursor-pointer"
                                                                        v-b-tooltip.hover
                                                                        :title="alert.status == 0 ? 'Mark as read' : 'Read'"
                                                                        @click.stop="markAlertReadOnly(alert, groupKey)">
                                                                        <img :src="getDeliverableIconSrc(alert.status)" class="notification-icon" />
                                                                    </div>
                                                                    <span v-if="alert.status == 0" class="alert-status">
                                                                        <i class="fas fa-circle"
                                                                            :class="alert.status == 0 ? 'text-primary' : 'text-primary'"
                                                                            v-b-tooltip.hover
                                                                            :title="alert.status == 0 ? 'Unread' : 'Read'"></i>
                                                                    </span>
                                                                    <p class="details cursor-pointer"
                                                                        v-b-tooltip.hover
                                                                        title="View detail"
                                                                        @click.stop="setAlert(alert, groupKey)">
                                                                        <span class="alert__name cursor-pointer fw-bold">{{ alert.title }}</span>
                                                                        <br>
                                                                        <span class="notification-sender">
                                                                            <span class="fw-bold">{{ alert.sender }} @ {{ getLocalAlertTime(alert.created_at) }}</span>
                                                                        </span>
                                                                        <br>
                                                                        <span class="note-message" v-html="processMessage(alert.message)"></span>
                                                                    </p>
                                                                </div>
                                                            </li>
                                                        </ul>

                                                        <div class="text-center py-3"
                                                            v-if="subGroup.hasMore && subGroup.total > 5">
                                                            <b-button
                                                                variant="outline-secondary"
                                                                size="sm"
                                                                class="load-more-btn"
                                                                @click.stop="loadMoreProjectSubgroup(groupKey, subGroup.deliverableId, subGroup.key)"
                                                                :disabled="projectSubgroupLoading[subGroup.key]">
                                                                <span v-if="projectSubgroupLoading[subGroup.key]">
                                                                    Loading...
                                                                </span>
                                                                <span v-else>
                                                                    Load More
                                                                </span>
                                                            </b-button>
                                                        </div>
                                                    </b-collapse>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Group By Deliverable: existing flat list within the group -->
                                        <div v-else>
                                            <ul class="list-unstyled notification-list-single-column">
                                                <li :key="'alert-' + index"
                                                    :id="`notification-alert-${alert.id}`"
                                                    v-for="(alert, index) in getGroupAlerts(groupKey).slice(1)"
                                                    class="group-alert-item notification-single-row"
                                                    :class="alert.status == 0 ? 'unread-notification' : 'read-notification'">
                                                    <div class="placeholder-n"></div>
                                                    <div class="notification-info-wrapper">
                                                        <div class="notification-icon-wrapper cursor-pointer"
                                                            v-b-tooltip.hover
                                                            :title="alert.status == 0 ? 'Mark as read' : 'Read'"
                                                            @click.stop="markAlertReadOnly(alert, groupKey)">
                                                            <img v-if="currentFilters.group_by === 'deliverable'" :src="getDeliverableIconSrc(alert.status)" class="notification-icon" />
                                                            <img v-else-if="currentFilters.group_by === 'global_alert'" src="@/csmworkflow/img/bell-regular.svg" class="notification-icon" />
                                                            <i v-else-if="currentFilters.group_by === 'project'" :class="['fas', 'fa-folder', 'fa-fw', 'notification-icon-fa']" :style="{ color: getProjectIconColor(alert.status) }"></i>
                                                        </div>
                                                        <span v-if="alert.status == 0" class="alert-status">
                                                            <i class="fas fa-circle"
                                                                :class="alert.status == 0 ? 'text-primary' : 'text-primary'"
                                                                v-b-tooltip.hover
                                                                :title="alert.status == 0 ? 'Unread' : 'Read'"></i>
                                                        </span>
                                                        <p class="details cursor-pointer"
                                                            v-b-tooltip.hover
                                                            title="View detail"
                                                            @click.stop="setAlert(alert, groupKey)">
                                                            <span class="alert__name cursor-pointer fw-bold">{{ alert.title }}</span>
                                                            <br>
                                                            <span class="notification-sender">
                                                                <span class="fw-bold">{{ alert.sender }} @ {{ getLocalAlertTime(alert.created_at) }}</span>
                                                            </span>
                                                            <br>
                                                            <span class="note-message" v-html="processMessage(alert.message)"></span>
                                                        </p>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>

                                        <!-- Load More Button - only show if total > 5 and has more to load -->
                                        <div class="text-center py-3" v-if="currentFilters.group_by !== 'project' && groupHasMore[groupKey] && getGroupTotal(groupKey) > 5">
                                            <b-button
                                                variant="outline-secondary"
                                                size="sm"
                                                class="load-more-btn"
                                                @click.stop="loadMoreGroup(groupKey)"
                                                :disabled="groupLoadingMore[groupKey]">
                                                <span v-if="groupLoadingMore[groupKey]">
                                                    Loading...
                                                </span>
                                                <span v-else>
                                                    Load More
                                                </span>
                                            </b-button>
                                        </div>
                                    </b-collapse>
                                </div>
                                <div class="dbox-right-side">
                                    <CollapseNotificationBtn :notifications="getGroupAlerts(groupKey)" :groupKey="groupKey"
                                        :expandAll="expandAllGroups" :totalCount="getCollapseTotalCount(groupKey)" :unreadTotal="getCollapseUnreadTotal(groupKey)"
                                        :has-header-preview="false" />
                                </div>
                            </div>

                              <!-- Simple Date Header (no collapse) -->
                              <div v-else>
                                  <div class="d-flex justify-content-between align-items-center mb-3 group-header-row">
                                      <h4 class="group-header mb-0">{{ $moment(groupKey).format('MMMM D, YYYY') }}
                                      </h4>
                                      <b-button class="btn btn-theme" variant="theme"
                                          @click.stop="makeGroupAlertsRead(group)" v-if="hasUnreadInGroup(group)">
                                          Mark All as Read
                                      </b-button>
                                  </div>
                                  <ul class="list-unstyled no-grouping-list">
                                    <li :key="'alert-' + index"
                                          :id="`notification-alert-${alert.id}`"
                                          v-for="(alert, index) in getDateGroupAlerts(group)"
                                          class="no-group-alert-item notification-single-row"
                                          :class="alert.status == 0 ? 'unread-notification' : 'read-notification'">
                                          <div class="notification-info-wrapper">
                                              <div class="notification-icon-wrapper cursor-pointer"
                                                  v-b-tooltip.hover
                                                  :title="alert.status == 0 ? 'Mark as read' : 'Read'"
                                                  @click.stop="markAlertReadOnly(alert)">
                                                <img v-if="alert.alert_model === 'deliverable' || alert.grouped_model === 'deliverable' || alert.alert_model === 'task'" :src="getDeliverableIconSrc(alert.status)" class="notification-icon" />
                                                <i v-else-if="alert.alert_model === 'project' || alert.grouped_model === 'project'" :class="['fas', 'fa-folder', 'fa-fw', 'notification-icon-fa']" :style="{ color: getProjectIconColor(alert.status) }"></i>
                                                <img v-else src="@/csmworkflow/img/bell-regular.svg" class="notification-icon" />
                                            </div>
                                            <!-- <span @click.stop="confirmDeleteAlert=true; deleteAlertId = alert.id;" class="remove-alert cursor-pointer">
                                            <i class="fas fa-trash"></i>
                                            </span>
                                            <span v-if="alert.status == 0" class="alert-status">
                                                <i class="fas fa-circle"
                                                    :class="alert.status == 0 ? 'text-primary' : 'text-primary'"
                                                    v-b-tooltip.hover
                                                    :title="alert.status == 0 ? 'Unread' : 'Read'"></i>
                                            </span>
                                            -->
                                            <p class="details cursor-pointer"
                                                v-b-tooltip.hover
                                                title="View detail"
                                                @click.stop="setAlert(alert)">
                                                <span class="alert__name cursor-pointer fw-bold">{{ alert.title
                                                    }}</span>
                                                <br>
                                                <span class="notification-sender">
                                                    <span class="fw-bold">{{ alert.sender }} @ {{
                                                        getLocalAlertTime(alert.created_at) }}</span>
                                                </span>
                                                <br>
                                                <span class="note-message"
                                                    v-html="processMessage(alert.message)"></span>
                                                </p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="pagination-wrapper">
                        <pagination :data="userAlerts" @pagination-change-page="onChangePage" :limit="5"></pagination>
                    </div>
                </div>
            </div>
        </div>

        <b-modal size="xl" hide-footer id="editDeliverableModal" title="Edit Deliverable" class="modal-edit-deliverable"
            @hide="editDeliverableModalHidden" @shown="pushRoute" @hidden="removeRoute">
            <EditModal :allContacts="allContacts" ref="refEditModal" :namespace="namespace" :tabIndex="tabIndex" />
        </b-modal>

        <b-modal size="lg" hide-footer id="editSocialModal" title="Edit Social Deliverable"
            class="modal-edit-social-deliverable" @hide="editSocialModalHidden" @shown="pushRoute"
            @hidden="removeRoute">
            <EditSocialModal ref="refEditSocialModal" :namespace="namespace" :tabIndex="tabIndex" />
        </b-modal>

        <b-modal size="xl" no-close-on-backdrop no-close-on-esc hide-footer id="editOrganicSocialMediaPlanModal"
            title="Edit Organic Social Media Plan" class="modal-edit-deliverable"
            @hide="editOrganicSocialModalPlanHidden" @shown="pushRoute" @hidden="removeRoute">
            <EditOrganicSocialMediaPlanModal ref="refEditOrganicSocialMediaPlanModal" :tabIndex="tabIndex"
                :namespace="namespace" />
        </b-modal>

    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import toast from "../toast";
import CreateGlobalAlert from "../components/common/CreateGlobalAlert";
import HeaderControls from "../components/common/HeaderControls";
import CollapseNotificationBtn from "../components/common/CollapseNotificationBtn";
import EditModal from "../components/deliverables/EditModal";
import EditOrganicSocialMediaPlanModal from "../components/deliverables/EditOrganicSocialMediaPlanModal";
import EditSocialModal from "../components/deliverables/EditSocialModal.vue";
import ViewTitleModal from "../components/common/ViewTitleModal";

export default {
    data() {
        return {
            namespace: "",
            alertTitle: '',
            alertDetail: '',
            runningTask: false,
            alertTime: '',
            alertSender: '',
            deleteAlertId: '',
            confirmDeleteAlert: false,
            tabIndex: 0,
            pendingExpandGroupKey: null,
            pendingFocusAlertId: null,
            forcedGroupKeys: [],
            routeIntentConsumed: false,
            routeIntentApplying: false,
            collapseStates: {},
            notificationReturnUrl: null,
            activeView: '-1',
            viewBtnLabel: 'Views',
            showNewViewTitleArea: false,
            showUpdateViewTitleArea: false,
            notificationPage: 1,
            notificationPageRestored: false,
            currentFilters: {
                query: '',
                status: 'unread',
                filterByDate: false,
                dateRange: {
                    startDate: null,
                    endDate: null
                },
                grouped_model: 'all',
                group_by: 'date'
            },
            availableFilters: {
                alert_types: [],
                grouped_models: [],
                user_preferences: {}
            },
              expandAllGroups: false,
            fetchingBatchTaskDeliverables: false,
            // Per-group alerts data for Load More functionality
            groupedAlertsData: {},
            groupLoadingMore: {},
            groupHasMore: {},
            // Per-project paging for the "project-level" section (non-deliverable alerts)
            projectSectionPages: {},
            projectSectionAlertsData: {},
            projectSectionHasMore: {},
            // Per-subgroup paging for Group By Project (deliverable/task sub-groups)
            projectSubgroupPages: {},
            projectSubgroupLoading: {},
            projectSubgroupAutoLoaded: {},
            projectSubgroupHasMore: {}
        }
    },
    components: {
        HeaderControls,
        CreateGlobalAlert,
        CollapseNotificationBtn,
        EditModal,
        EditOrganicSocialMediaPlanModal,
        EditSocialModal,
        ViewTitleModal,
    },
    computed: {
        ...mapGetters(['userAlerts', 'systemSettings', 'deliverableDetail', 'projectDetail', 'allContacts', 'taskHighlighted', 'userViews']),
        ...mapState({
            getDeliverableTemplateSlug(state, getters) {
                return getters['getDeliverableTemplateSlug']
            },
        }),
        notificationViews() {
            return (this.userViews || []).filter(v => v && v.view_type === 'notification');
        },
        presetViewsNotification() {
            const todayStart = this.$moment().startOf('day').toISOString();
            const todayEnd = this.$moment().endOf('day').toISOString();
            const weekStart = this.$moment().startOf('week').startOf('day').toISOString();
            const weekEnd = this.$moment().endOf('week').endOf('day').toISOString();

            return [
                {
                    id: 'np1',
                    title: 'Today',
                    saved_data: JSON.stringify({
                        query: '',
                        status: 'unread',
                        filterByDate: true,
                        dateRange: { startDate: todayStart, endDate: todayEnd },
                        grouped_model: 'all',
                        group_by: 'date',
                        alert_types: [],
                        quickFilter: null
                    }),
                    preset: true
                },
                {
                    id: 'np2',
                    title: 'This Week',
                    saved_data: JSON.stringify({
                        query: '',
                        status: 'unread',
                        filterByDate: true,
                        dateRange: { startDate: weekStart, endDate: weekEnd },
                        grouped_model: 'all',
                        group_by: 'date',
                        alert_types: [],
                        quickFilter: null
                    }),
                    preset: true
                }
            ];
        },
        isPresetNotificationViewActive() {
            const activeId = String(this.activeView);
            return (this.presetViewsNotification || []).some(v => v && String(v.id) === activeId);
        },
        viewModalShowCreateView() {
            return this.activeView === '-1' && !this.showNewViewTitleArea && !this.showUpdateViewTitleArea;
        },
        viewModalShowUpdateView() {
            return this.activeView !== '-1'
                && !this.isPresetNotificationViewActive
                && !this.showNewViewTitleArea
                && !this.showUpdateViewTitleArea;
        },
        markAllButtonLabel() {
            switch (this.currentFilters.group_by) {
                case 'deliverable':
                    return 'Mark All Deliverables as Read';
                case 'project':
                    return 'Mark All Projects as Read';
                default:
                    return 'Mark All Notifications As Read';
            }
        },
        headerText() {
            switch (this.currentFilters.group_by) {
                case 'date':
                    return 'Notifications By Date';
                case 'deliverable':
                    return 'Notifications By Deliverable';
                case 'project':
                    return 'Notifications By Project';
                default:
                    return 'Your Messages';
            }
        },
        groupedAlerts() {
            if (!this.userAlerts.data || this.currentFilters.group_by === 'none') {
                return {};
            }

            const grouped = {};

            this.userAlerts.data.forEach(alert => {
                let groupKey = null;

                if (this.currentFilters.group_by === 'date') {
                    // Group by date (format: YYYY-MM-DD)
                    groupKey = this.$moment(alert.created_at).format('YYYY-MM-DD');
                } else if (this.currentFilters.group_by === 'deliverable') {
                    // Group by deliverable using alert's grouped_model_id
                    if (!(alert.grouped_model === 'deliverable' && alert.grouped_model_id)) return;
                    const deliverableGroupId = alert.deliverable_group_id || alert.grouped_model_id;
                    groupKey = `deliverable-${deliverableGroupId}`;
                } else if (this.currentFilters.group_by === 'project') {
                    // Group by project using alert's grouped_model_id
                    if (!(alert.grouped_model === 'project' && alert.grouped_model_id)) return;
                    groupKey = `project-${alert.grouped_model_id}`;
                }

                if (!groupKey) return;
                if (!grouped[groupKey]) {
                    grouped[groupKey] = [];
                }
                grouped[groupKey].push(alert);
            });

            // Ensure any route-targeted group is present even if it isn't included in the current page of results.
            if (['deliverable', 'project'].includes(this.currentFilters.group_by) && Array.isArray(this.forcedGroupKeys)) {
                const totals = (this.userAlerts && this.userAlerts.groupTotals) ? this.userAlerts.groupTotals : {};
                this.forcedGroupKeys.forEach((groupKey) => {
                    if (!groupKey) return;
                    if (!groupKey.startsWith(`${this.currentFilters.group_by}-`)) return;
                    if (!grouped[groupKey]) {
                        const meta = totals[groupKey];
                        const hasTotal = typeof meta === 'object' && meta !== null
                            ? Number(meta.total || 0) > 0
                            : Number(meta || 0) > 0;
                        if (hasTotal) {
                            grouped[groupKey] = [];
                        }
                    }
                });
            }

            // Sort each group by created_at descending (latest first)
            Object.keys(grouped).forEach(key => {
                grouped[key].sort((a, b) => (a.status - b.status) || (new Date(b.created_at) - new Date(a.created_at)));
            });

            return grouped;
        },
        visibleGroupedAlerts() {
            const grouped = this.groupedAlerts;
            if (this.currentFilters.group_by !== 'date') {
                const filtered = {};
                Object.keys(grouped).forEach((key) => {
                    const alerts = this.getGroupAlerts(key) || [];
                    const meta = this.getGroupMeta(key);
                    // Hide stale placeholder groups that have no alerts and no backend metadata.
                    if (alerts.length === 0 && !meta) return;
                    filtered[key] = grouped[key];
                });
                return filtered;
            }

            const filtered = {};
            Object.keys(grouped).forEach(key => {
                const alerts = grouped[key] || [];
                if (this.getDateGroupAlerts(alerts).length) {
                    filtered[key] = alerts;
                }
            });
            return filtered;
        },
    },
    mounted() {
        console.log('Mounted UserGlobalAlert.vue', this.systemSettings);
        //fetch system settings if not already fetched
        if (!this.systemSettings || Object.keys(this.systemSettings).length === 0) {
            this.fetchSystemSettings();
        }

        this.$store.dispatch('fetchViews').then(() => {
            this.setActiveView();
        });

        this.applyRouteIntent();
        this.updateNotificationDocumentTitle(this.currentFilters.group_by);

        this.$root.$on("bv::modal::shown", (bvModal, modalId) => {
            if (modalId == 'editDeliverableModal') {
                if (this.taskHighlighted) {
                    let editModal = $("#editDeliverableModal");

                    this.$nextTick(() => {
                        setTimeout(() => {
                            let curEl = $(".task-fields .field-block.highlight");
                            const elOffset = curEl.offset();
                            editModal.scrollTop(elOffset.top - 0.4 * window.innerHeight);
                        }, 100);
                    });
                }
            }
        });

        // Track collapse state so route-intent expansion can avoid double-toggling (open then close).
        this._collapseStateListener = (id, state) => {
            if (!id) return;
            this.$set(this.collapseStates, id, state);
        };
        this.$root.$on("bv::collapse::state", this._collapseStateListener);
        this._popstateHandler = () => {
            this.applyRouteIntent();
            this.fetchAlertsWithFilters().then(() => this.applyPendingExpansion());
        };
        window.addEventListener('popstate', this._popstateHandler);
    },
    beforeDestroy() {
        if (this._collapseStateListener) {
            this.$root.$off("bv::collapse::state", this._collapseStateListener);
        }
        if (this._popstateHandler) {
            window.removeEventListener('popstate', this._popstateHandler);
            this._popstateHandler = null;
        }
    },
      watch: {
          '$route.query': {
              deep: true,
              handler() {
                  //const prevGroupBy = this.currentFilters.group_by;
                  this.applyRouteIntent();
                  this.updateNotificationDocumentTitle(this.currentFilters.group_by);
  
                  // If group_by changed, refetch to ensure correct grouping dataset
                  // if (this.currentFilters.group_by !== prevGroupBy) {
                  this.fetchAlertsWithFilters().then(() => this.applyPendingExpansion());
                 //   return;
                 //}

                // If only expandGroupKey changed, just expand locally
               // this.applyPendingExpansion();
            }
        }
    },
    methods: {
        ...mapActions(['fetchUserAlerts', 'fetchProjectDeliverableById', 'getProjectNumberFromId', 'getProjectNumberFromDeliverableId', 'fetchSystemSettings', 'getDeliverableDetailByTask', 'fetchGroupedAlerts']),
        ...mapMutations(['setDataLoading']),
        buildNotificationReturnUrl(alert, groupKey = null) {
            const base = this.$router ? this.$router.resolve({ name: 'userGlobalAlert' }).href : '/user-global-alert';
            const nextGroupBy = this.currentFilters.group_by || 'date';
            const nextPage = this.notificationPage || 1;
            const resolvedGroupKey = groupKey || this.getAlertGroupKey(alert);
            const query = {
                group_by: nextGroupBy,
                page: String(nextPage)
            };
            if (alert && alert.id) {
                query.focusAlertId = String(alert.id);
            }
            if (resolvedGroupKey) {
                query.expandGroupKey = String(resolvedGroupKey);
            }
            const qs = new URLSearchParams(query).toString();
            const href = `${base}?${qs}`;
            return href.startsWith('http') ? href : `${window.location.origin}${href}`;
        },
        markHistoryFromNotifications() {
            const baseState = (history.state && typeof history.state === 'object') ? history.state : {};
            if (!this.notificationReturnUrl) {
                return;
            }
            history.replaceState({ ...baseState, fromNotifications: true, returnUrl: this.notificationReturnUrl }, null, window.location.href);
        },
        viewSelectModalHidden() {
            this.showNewViewTitleArea = false;
            this.showUpdateViewTitleArea = false;
        },
        updatePerfectScroll() {
            let self = this;
            setTimeout(function() {
                if (typeof self.$refs.views__scroll != 'undefined') {
                    self.$refs.views__scroll.update();
                }
            }, 1);
        },
        closeViewSelectModal() {
            this.$bvModal.hide("headerViewSelectModal");
        },
        modalUpdateView() {
            if (!this.viewModalShowUpdateView) {
                return;
            }
            localStorage.setItem('notificationFilters', JSON.stringify(this.currentFilters || {}));
            this.showUpdateViewTitleArea = true;
        },
        modalSaveView() {
            localStorage.setItem('notificationFilters', JSON.stringify(this.currentFilters || {}));
            this.showNewViewTitleArea = true;
        },
        setActiveView() {
            if (localStorage.getItem('notificationActiveSave')) {
                this.activeView = localStorage.getItem('notificationActiveSave');
                this.viewBtnLabel = localStorage.getItem('notificationActiveSaveTitle') || 'Views';
            } else {
                this.activeView = '-1';
                this.viewBtnLabel = 'Views';
            }
        },
        handleResetFilter() {
            localStorage.removeItem('notificationActiveSave');
            localStorage.removeItem('notificationActiveSaveTitle');
            localStorage.removeItem('notificationActiveSaveData');
            this.setActiveView();
            if (this.$refs.headerControls && typeof this.$refs.headerControls.applyNotificationViewFilters === 'function') {
                this.$refs.headerControls.applyNotificationViewFilters({
                    query: '',
                    status: 'all',
                    filterByDate: false,
                    dateRange: { startDate: new Date(), endDate: new Date() },
                    grouped_model: 'all',
                    alert_types: [],
                    group_by: this.currentFilters.group_by || 'date',
                    quickFilter: null
                });
            }
        },
        saveView() {
            localStorage.setItem('notificationFilters', JSON.stringify(this.currentFilters || {}));
            this.$bvModal.show("viewTitleModal");
        },
        updateView() {
            if (!this.viewModalShowUpdateView) {
                return;
            }
            localStorage.setItem('notificationFilters', JSON.stringify(this.currentFilters || {}));
            this.$bvModal.show("viewTitleUpdateModal");
        },
        loadViewFromModal(viewData) {
            this.loadView(viewData);
            this.$bvModal.hide("headerViewSelectModal");
        },
        loadView(viewData) {
            const filters = viewData && viewData.saved_data ? JSON.parse(viewData.saved_data) : {};
            this.activeView = String(viewData.id);
            this.viewBtnLabel = viewData.title;
            localStorage.setItem('notificationActiveSave', String(viewData.id));
            localStorage.setItem('notificationActiveSaveTitle', viewData.title);
            localStorage.setItem('notificationActiveSaveData', viewData.saved_data);
            localStorage.setItem('notificationFilters', JSON.stringify(filters));
            if (this.$refs.headerControls && typeof this.$refs.headerControls.applyNotificationViewFilters === 'function') {
                this.$refs.headerControls.applyNotificationViewFilters(filters);
            }
        },
        removeView(viewId) {
            if (String(viewId) === String(localStorage.getItem('notificationActiveSave'))) {
                this.handleResetFilter();
            }
            this.$store.dispatch('removeView', viewId);
        },
        fetchAlertsWithFilters(page = null) {
            const nextPage = Number.isFinite(page) && page > 0 ? page : (this.notificationPage || 1);
            this.notificationPage = nextPage;
            // Reset grouped alerts data when filters change
            this.groupedAlertsData = {};
            this.groupLoadingMore = {};
            this.groupHasMore = {};
            this.projectSectionAlertsData = {};

            // Fetch alerts with current filter parameters
            return this.$store.dispatch('fetchUserAlerts', {
                page: nextPage,
                ...this.currentFilters
            }).then(() => {
                if (this.userAlerts.availableFilters) {
                    this.availableFilters = this.userAlerts.availableFilters;
                }

                // Initialize per-group data for deliverable/project grouping
                if (this.currentFilters.group_by === 'deliverable' || this.currentFilters.group_by === 'project') {
                    this.initializeGroupedAlertsData();
                }
            }).finally(() => {
                this.setDataLoading(false);
            });
        },
        applyRouteIntent() {
            const query = this.getQueryFromLocation();
            const groupBy = query.group_by;
            const expandGroupKey = query.expandGroupKey;
            const focusAlertId = query.focusAlertId;
            const routePage = this.getRoutePage(query.page);

            if (groupBy && ['date', 'deliverable', 'project', 'none'].includes(groupBy)) {
                this.currentFilters.group_by = groupBy;
            }

            if (routePage) {
                this.notificationPage = routePage;
            }

            this.pendingExpandGroupKey = expandGroupKey || null;
            this.pendingFocusAlertId = focusAlertId || null;
            if (expandGroupKey && this.currentFilters.group_by && expandGroupKey.startsWith(`${this.currentFilters.group_by}-`)) {
                this.forcedGroupKeys = [expandGroupKey];
            } else {
                this.forcedGroupKeys = [];
            }
            this.routeIntentConsumed = false;
            this.updateNotificationDocumentTitle(this.currentFilters.group_by);
        },
        async applyPendingExpansion() {
            if (!this.pendingExpandGroupKey && !this.pendingFocusAlertId) return;
            if (!['deliverable', 'project'].includes(this.currentFilters.group_by)) {
                this.applyPendingFocusScroll();
                return;
            }
            if (this.routeIntentApplying) return;

            const groupKey = this.resolveTargetGroupKey(this.pendingExpandGroupKey, this.pendingFocusAlertId);
            if (!groupKey) return;

            this.routeIntentApplying = true;
            let clearedApplying = false;
            const clearApplying = () => {
                if (clearedApplying) return;
                clearedApplying = true;
                this.routeIntentApplying = false;
            };

            try {
                await this.ensureGroupLoadedForRouteIntent(groupKey, this.pendingFocusAlertId);
                await new Promise(resolve => this.$nextTick(resolve));

                const collapseId = `notification-group-collapse-${groupKey}`;

                const isExpanded = () => {
                    const known = this.collapseStates[collapseId];
                    if (typeof known === 'boolean') return known;
                    const el = document.getElementById(collapseId);
                    return !!(el && el.classList && el.classList.contains('show'));
                };

                const waitForCollapseState = (desiredState, timeoutMs = 1200) => new Promise((resolve) => {
                    const handler = (id, state) => {
                        if (id === collapseId && state === desiredState) cleanup(true);
                    };
                    const cleanup = (result) => {
                        this.$root.$off("bv::collapse::state", handler);
                        clearTimeout(timer);
                        resolve(result);
                    };
                    this.$root.$on("bv::collapse::state", handler);
                    const timer = setTimeout(() => cleanup(false), timeoutMs);
                });

                // Only toggle when currently collapsed, otherwise a second call would close it.
                if (!isExpanded()) {
                    this.$root.$emit('bv::toggle::collapse', collapseId);
                    await waitForCollapseState(true);
                }

                await new Promise(resolve => this.$nextTick(resolve));

                let applied = false;
                const consume = () => {
                    if (applied) return;
                    applied = true;
                    this.pendingExpandGroupKey = null;
                    this.pendingFocusAlertId = null;
                    this.routeIntentConsumed = true;
                    clearApplying();
                };

                const scrollToTarget = () => {
                    const focusId = this.pendingFocusAlertId ? parseInt(this.pendingFocusAlertId, 10) : null;
                    const focusEl = focusId ? document.getElementById(`notification-alert-${focusId}`) : null;
                    const boundary = document.getElementById('content');
                    if (focusEl) {
                        if (boundary) {
                            this.scrollIntoViewWithinBoundary(focusEl, boundary, { block: 'nearest', behavior: 'smooth', offset: 120 });
                        } else if (typeof focusEl.scrollIntoView === 'function') {
                        focusEl.scrollIntoView({ block: 'start' });
                        }
                        return true;
                    }

                    const anchor = document.querySelector(`.notification-group-collapsible-${groupKey}`);
                    if (anchor) {
                        if (boundary) {
                            this.scrollIntoViewWithinBoundary(anchor, boundary, { block: 'nearest', behavior: 'smooth', offset: 120 });
                        } else if (typeof anchor.scrollIntoView === 'function') {
                        anchor.scrollIntoView({ block: 'start' });
                        }
                        return true;
                    }
                    return false;
                };

                const scheduleScroll = (attempt = 0) => {
                    if (applied) return;
                    const maxAttempts = 20;
                    if (scrollToTarget()) {
                        consume();
                        return;
                    }
                    if (attempt >= maxAttempts) {
                        consume();
                        return;
                    }
                    setTimeout(() => scheduleScroll(attempt + 1), 100);
                };

                scheduleScroll(0);
            } catch (error) {
                clearApplying();
                console.error('Failed to apply route intent expansion:', error);
            }
        },
        async ensureGroupLoadedForRouteIntent(groupKey, focusAlertId) {
            if (!groupKey || typeof groupKey !== 'string') {
                return;
            }
            if (!['deliverable', 'project'].includes(this.currentFilters.group_by)) {
                return;
            }

            const focusId = focusAlertId ? parseInt(focusAlertId, 10) : null;
            const existing = this.getGroupAlerts(groupKey) || [];
            if (existing.length && (!focusId || existing.some(a => a.id === focusId))) {
                return;
            }

            const groupType = this.currentFilters.group_by;
            if (!groupKey.startsWith(`${groupType}-`)) {
                return;
            }

            const groupId = groupKey.replace(`${groupType}-`, '');
            const perPage = focusId ? 50 : (groupType === 'project' ? 20 : 20);
            const maxPages = focusId ? 25 : 1;

            let merged = [];
            let mergedIds = new Set();
            let total = 0;
            let hasMore = true;
            let lastPage = 0;

            try {
                for (let page = 1; page <= maxPages && hasMore; page += 1) {
                    const response = await this.$store.dispatch('fetchGroupedAlerts', {
                        group_type: groupType,
                        group_id: groupId,
                        page,
                        per_page: perPage,
                        query: this.currentFilters.query,
                        status: this.currentFilters.status
                    });

                    const rows = response && Array.isArray(response.data) ? response.data : [];
                    total = response && typeof response.total !== 'undefined' ? response.total : total;
                    hasMore = !!(response && response.has_more);
                    lastPage = page;

                    rows.forEach((alert) => {
                        if (!alert || typeof alert.id === 'undefined') return;
                        if (mergedIds.has(alert.id)) return;
                        mergedIds.add(alert.id);
                        merged.push(alert);
                    });

                    if (focusId && merged.some(a => a && a.id === focusId)) {
                        hasMore = false;
                        break;
                    }
                }
            } catch (error) {
                console.error('Failed to fetch route-targeted group alerts:', error);
            }

            if (!merged.length) {
                return;
            }

            this.$set(this.groupedAlertsData, groupKey, {
                alerts: merged,
                page: lastPage || 1,
                total: total || merged.length
            });
            this.$set(this.groupHasMore, groupKey, hasMore && merged.length < (total || merged.length));
        },
        resolveTargetGroupKey(expandGroupKey, focusAlertId) {
            if (expandGroupKey) {
                const totals = (this.userAlerts && this.userAlerts.groupTotals) ? this.userAlerts.groupTotals : {};
                const exists = (this.groupedAlertsData && this.groupedAlertsData[expandGroupKey])
                    || (this.groupedAlerts && this.groupedAlerts[expandGroupKey]);
                if (!exists && totals && typeof totals === 'object' && totals[expandGroupKey]) {
                    return expandGroupKey;
                }
                if (exists) return expandGroupKey;
            }

            if (focusAlertId) {
                const parsedId = parseInt(focusAlertId, 10);
                const keys = Object.keys(this.groupedAlertsData || {});
                for (const key of keys) {
                    const alerts = this.groupedAlertsData[key]?.alerts || [];
                    if (alerts.some(a => a.id === parsedId)) {
                        return key;
                    }
                }
            }

            return null;
        },
        /**
         * Initialize per-group alerts data using groupTotals from the main fetch response
         */
        initializeGroupedAlertsData() {
            this.projectSectionPages = {};
            this.projectSubgroupPages = {};
            this.projectSubgroupLoading = {};
            this.projectSubgroupAutoLoaded = {};
            this.projectSectionAlertsData = {};
            this.projectSectionHasMore = {};
            this.projectSubgroupHasMore = {};
            const grouped = this.groupedAlerts;
            const groupKeys = Object.keys(grouped);

            groupKeys.forEach(groupKey => {
                const total = this.getGroupTotal(groupKey, grouped[groupKey].length);
                const loadedCount = grouped[groupKey].length;

                this.$set(this.groupedAlertsData, groupKey, {
                    alerts: [...grouped[groupKey]],
                    page: 1,
                    total: total,
                    last_page: null
                });
                if (this.currentFilters.group_by === 'project') {
                    this.$set(this.projectSectionPages, groupKey, 1);
                    const projectAlerts = (grouped[groupKey] || []).filter(a => !a || !a.deliverable_group_id);
                    this.$set(this.projectSectionAlertsData, groupKey, {
                        alerts: [...projectAlerts],
                        page: 1,
                        total: this.getProjectSectionTotal(groupKey),
                        last_page: null
                    });
                    this.$set(this.projectSectionHasMore, groupKey, true);
                }

                // Has more if loaded count is less than total
                this.$set(this.groupHasMore, groupKey, loadedCount < total);
            });

            // Group titles are provided by backend in userAlerts.groupTotals
            this.applyPendingExpansion();
        },
        /**
         * Load more alerts for a specific group
         */
        async loadMoreGroup(groupKey) {
            if (this.groupLoadingMore[groupKey]) return;

            this.$set(this.groupLoadingMore, groupKey, true);

            const groupType = this.currentFilters.group_by; // 'deliverable' or 'project'
            const groupId = groupKey.replace(`${groupType}-`, '');
            const currentData = this.groupedAlertsData[groupKey] || { alerts: [], page: 1, last_page: null };
            if (currentData.last_page && currentData.page >= currentData.last_page) {
                this.$set(this.groupHasMore, groupKey, false);
                this.$set(this.groupLoadingMore, groupKey, false);
                return;
            }
            const nextPage = currentData.page + 1;

            try {
                const perPage = groupType === 'project' ? 20 : 5;
                const response = await this.$store.dispatch('fetchGroupedAlerts', {
                    group_type: groupType,
                    group_id: groupId,
                    page: nextPage,
                    per_page: perPage,
                    query: this.currentFilters.query,
                    status: this.currentFilters.status
                });

                if (response && response.data) {
                    // Merge new alerts with existing ones, avoiding duplicates
                    const existingIds = new Set(currentData.alerts.map(a => a.id));
                    const newAlerts = response.data.filter(a => !existingIds.has(a.id));

                    this.$set(this.groupedAlertsData, groupKey, {
                        alerts: [...currentData.alerts, ...newAlerts],
                        page: response && response.current_page ? response.current_page : nextPage,
                        total: response.total,
                        last_page: response && response.last_page ? response.last_page : currentData.last_page
                    });

                    this.$set(this.groupHasMore, groupKey, response.has_more);
                }
            } catch (error) {
                console.error('Failed to load more alerts:', error);
            } finally {
                this.$set(this.groupLoadingMore, groupKey, false);
            }
        },
        /**
         * Get alerts for a group - returns merged data if available
         */
        getGroupAlerts(groupKey) {
            if (this.groupedAlertsData[groupKey]) {
                return this.groupedAlertsData[groupKey].alerts;
            }
            return this.groupedAlerts[groupKey] || [];
        },
        getProjectSectionAlerts(projectGroupKey) {
            if (this.projectSectionAlertsData && this.projectSectionAlertsData[projectGroupKey]) {
                return this.projectSectionAlertsData[projectGroupKey].alerts || [];
            }
            const alerts = this.getGroupAlerts(projectGroupKey) || [];
            return alerts
                .filter(a => !a || !a.deliverable_group_id)
                .sort((a, b) => (a.status - b.status) || (new Date(b.created_at) - new Date(a.created_at)));
        },
        getProjectSectionVisibleAlerts(projectGroupKey) {
            const perPage = 5;
            const currentPage = this.projectSectionPages[projectGroupKey] || 1;
            const showCount = Math.max(currentPage, 1) * perPage;
            return (this.getProjectSectionAlerts(projectGroupKey) || []).slice(0, showCount);
        },
        projectSectionHasUnread(projectGroupKey) {
            const alerts = this.getProjectSectionAlerts(projectGroupKey) || [];
            return alerts.some(a => a && a.status === 0);
        },
        getProjectSectionTotal(projectGroupKey) {
            const loaded = this.getProjectSectionAlerts(projectGroupKey).length;
            if (this.projectSectionAlertsData && this.projectSectionAlertsData[projectGroupKey] && typeof this.projectSectionAlertsData[projectGroupKey].total !== 'undefined') {
                const storedTotal = Number(this.projectSectionAlertsData[projectGroupKey].total);
                if (Number.isFinite(storedTotal)) {
                    return Math.max(storedTotal, loaded);
                }
            }
            const groupTotal = Number(this.getGroupTotal(projectGroupKey));
            if (!Number.isFinite(groupTotal)) {
                return loaded;
            }

            const subTotals = (this.userAlerts && this.userAlerts.subgroupTotals)
                ? this.userAlerts.subgroupTotals[projectGroupKey]
                : null;

            if (subTotals && typeof subTotals === 'object') {
                const deliverableTotal = Object.values(subTotals).reduce((sum, meta) => {
                    const value = meta && typeof meta.total !== 'undefined' ? Number(meta.total) : 0;
                    return sum + (Number.isFinite(value) ? value : 0);
                }, 0);

                const projectTotal = groupTotal - deliverableTotal;
                if (Number.isFinite(projectTotal) && projectTotal >= 0) {
                    return Math.max(projectTotal, loaded);
                }
            }

            return Math.max(groupTotal, loaded);
        },
        projectSectionHasMoreToShow(projectGroupKey) {
            if (this.projectSectionHasMore[projectGroupKey] === false) {
                return false;
            }
            const total = this.getProjectSectionTotal(projectGroupKey);
            const visible = this.getProjectSectionVisibleAlerts(projectGroupKey).length;
            return visible < total;
        },
        applyPendingFocusScroll() {
            if (!this.pendingFocusAlertId) return false;
            const focusId = parseInt(this.pendingFocusAlertId, 10);
            if (!focusId) return false;
            const focusEl = document.getElementById(`notification-alert-${focusId}`);
            const boundary = document.getElementById('content');
            if (focusEl) {
                if (boundary) {
                    this.scrollIntoViewWithinBoundary(focusEl, boundary, { block: 'nearest', behavior: 'smooth', offset: 120 });
                } else if (typeof focusEl.scrollIntoView === 'function') {
                    focusEl.scrollIntoView({ block: 'start' });
                }
                this.pendingFocusAlertId = null;
                this.routeIntentConsumed = true;
                return true;
            }
            return false;
        },
        scrollIntoViewWithinBoundary(el, boundary, opts = {}) {
            if (!el || !boundary) return false;
            const behavior = opts.behavior || 'smooth';
            const block = opts.block || 'nearest';
            const offset = Number.isFinite(opts.offset) ? opts.offset : 0;
            const boundaryRect = boundary.getBoundingClientRect();
            const elRect = el.getBoundingClientRect();
            const topLimit = boundaryRect.top + offset;
            const bottomLimit = boundaryRect.bottom - offset;
            let delta = 0;

            if (block === 'start') {
                delta = elRect.top - topLimit;
            } else if (block === 'center') {
                const elCenter = elRect.top + elRect.height / 2;
                const boundaryCenter = boundaryRect.top + boundaryRect.height / 2;
                delta = elCenter - boundaryCenter;
            } else if (block === 'end') {
                delta = elRect.bottom - bottomLimit;
            } else {
                if (elRect.top < topLimit) {
                    delta = elRect.top - topLimit;
                } else if (elRect.bottom > bottomLimit) {
                    delta = elRect.bottom - bottomLimit;
                }
            }

            if (delta !== 0) {
                const next = boundary.scrollTop + delta;
                if (typeof boundary.scrollTo === 'function') {
                    boundary.scrollTo({ top: next, behavior });
                } else {
                    boundary.scrollTop = next;
                }
            }
            return true;
        },
        async loadMoreProjectSection(projectGroupKey) {
            const perPage = 5;
            const currentPage = this.projectSectionPages[projectGroupKey] || 1;
            const currentData = this.projectSectionAlertsData[projectGroupKey] || { alerts: [], page: 1, total: 0, last_page: null };
            if (currentData.last_page && currentPage >= currentData.last_page) {
                this.$set(this.projectSectionHasMore, projectGroupKey, false);
                return;
            }
            const nextPage = currentPage + 1;
            const required = nextPage * perPage;

            const loadedProjectLevel = this.getProjectSectionAlerts(projectGroupKey).length;
            if (loadedProjectLevel >= required) {
                this.$set(this.projectSectionPages, projectGroupKey, nextPage);
                return;
            }

            const projectId = projectGroupKey.replace('project-', '');
            if (!projectId) return;

            let response = null;
            try {
                response = await this.$store.dispatch('fetchGroupedAlerts', {
                    group_type: 'project',
                    group_id: projectId,
                    project_section_only: true,
                    page: nextPage,
                    per_page: perPage,
                    query: this.currentFilters.query,
                    status: this.currentFilters.status
                });

                const existingIds = new Set((currentData.alerts || []).map(a => a.id));
                const newAlerts = (response && response.data) ? response.data.filter(a => !existingIds.has(a.id)) : [];

                this.$set(this.projectSectionAlertsData, projectGroupKey, {
                    alerts: [...(currentData.alerts || []), ...newAlerts],
                    page: response && response.current_page ? response.current_page : nextPage,
                    total: response && typeof response.total !== 'undefined' ? response.total : currentData.total,
                    last_page: response && response.last_page ? response.last_page : currentData.last_page
                });

                if (response && response.has_more === false) {
                    this.$set(this.projectSectionHasMore, projectGroupKey, false);
                } else if (response && response.has_more === true) {
                    this.$set(this.projectSectionHasMore, projectGroupKey, true);
            }
            } catch (e) {
                console.error('Failed to load more project-level alerts:', e);
            }

            this.$set(this.projectSectionPages, projectGroupKey, response && response.current_page ? response.current_page : nextPage);
        },
        getProjectSubgroupMeta(projectGroupKey, deliverableGroupId) {
            const totals = (this.userAlerts && this.userAlerts.subgroupTotals) ? this.userAlerts.subgroupTotals : {};
            const projectTotals = totals ? totals[projectGroupKey] : null;
            if (!projectTotals) return null;
            return projectTotals[String(parseInt(deliverableGroupId, 10))] || null;
        },
        getProjectSubgroups(projectGroupKey) {
            const alerts = this.getGroupAlerts(projectGroupKey) || [];
            const groups = {};
            const perPage = 5;

            const totals = (this.userAlerts && this.userAlerts.subgroupTotals) ? this.userAlerts.subgroupTotals : {};
            const projectTotals = totals ? totals[projectGroupKey] : null;

            if (projectTotals && typeof projectTotals === 'object') {
                Object.keys(projectTotals).forEach((keyId) => {
                    const deliverableGroupId = parseInt(keyId, 10);
                    if (!deliverableGroupId || deliverableGroupId <= 0) return;
                    const meta = projectTotals[keyId];
                    const total = meta && typeof meta.total !== 'undefined' ? Number(meta.total) : null;

                    const key = `${projectGroupKey}-deliverable-${deliverableGroupId}`;
                    groups[key] = {
                        key,
                        isProjectSection: false,
                        deliverableId: deliverableGroupId,
                        title: (meta && meta.title) ? meta.title : `Deliverable #${deliverableGroupId}`,
                        allAlerts: [],
                        latestAt: null,
                        total: Number.isFinite(total) ? total : 0,
                        unread: meta && typeof meta.unread !== 'undefined' ? Number(meta.unread) : 0,
                        deleted: !!(meta && meta.deleted),
                    };
                });
            }

            alerts.forEach(alert => {
                const deliverableGroupId = alert && alert.deliverable_group_id ? parseInt(alert.deliverable_group_id, 10) : null;
                if (!deliverableGroupId || deliverableGroupId <= 0) return;

                const key = `${projectGroupKey}-deliverable-${deliverableGroupId}`;
                if (!groups[key]) {
                    groups[key] = {
                        key,
                        isProjectSection: false,
                        deliverableId: deliverableGroupId,
                        title: alert.deliverable_title || `Deliverable #${deliverableGroupId}`,
                        allAlerts: [],
                        latestAt: null,
                    };
                }

                groups[key].allAlerts.push(alert);
                const createdAt = alert && alert.created_at ? new Date(alert.created_at).getTime() : 0;
                if (!groups[key].latestAt || createdAt > groups[key].latestAt) {
                    groups[key].latestAt = createdAt;
                }
            });

            const result = Object.values(groups).map(g => {
                g.allAlerts.sort((a, b) => (a.status - b.status) || (new Date(b.created_at) - new Date(a.created_at)));

                const meta = this.getProjectSubgroupMeta(projectGroupKey, g.deliverableId);
                if (meta && typeof meta.total !== 'undefined') {
                    g.total = Number(meta.total);
                } else if (typeof g.total === 'undefined') {
                    g.total = g.allAlerts.length;
                }
                if (meta && typeof meta.unread !== 'undefined') {
                    g.unread = Number(meta.unread);
                } else if (typeof g.unread === 'undefined') {
                    g.unread = (g.allAlerts || []).filter(a => a.status === 0).length;
                }
                g.deleted = !!(meta && meta.deleted);
                if (meta && meta.title) {
                    g.title = meta.title;
                }

                const currentPages = this.projectSubgroupPages[g.key] || 1;
                const showCount = Math.max(currentPages, 1) * perPage;
                g.alerts = g.allAlerts.slice(0, showCount);
                if (this.projectSubgroupHasMore[g.key] === false) {
                    g.hasMore = false;
                } else {
                g.hasMore = g.total > g.alerts.length;
                }

                if (g.total > 0 && g.total <= perPage && g.alerts.length === 0 && !this.projectSubgroupLoading[g.key] && !this.projectSubgroupAutoLoaded[g.key]) {
                    this.$set(this.projectSubgroupAutoLoaded, g.key, true);
                    this.loadMoreProjectSubgroup(projectGroupKey, g.deliverableId, g.key, 1);
                }

                return g;
            });

            result.sort((a, b) => (b.latestAt || 0) - (a.latestAt || 0));
            return result;
        },
        async loadMoreProjectSubgroup(projectGroupKey, deliverableGroupId, subGroupKey, pageOverride = null) {
            const projectId = projectGroupKey.replace('project-', '');
            const deliverableId = parseInt(deliverableGroupId, 10);
            if (!projectId || !deliverableId) return;

            if (this.projectSubgroupLoading[subGroupKey]) return;
            this.$set(this.projectSubgroupLoading, subGroupKey, true);

            const currentPage = this.projectSubgroupPages[subGroupKey] || 1;
            if (this.projectSubgroupHasMore[subGroupKey] === false && !pageOverride) {
                return;
            }

            try {
                const nextPage = pageOverride ? pageOverride : (currentPage + 1);

                // If the project bucket already has enough alerts loaded for the next "page", just reveal them.
                const alreadyLoaded = (this.getGroupAlerts(projectGroupKey) || [])
                    .filter(a => a && parseInt(a.deliverable_group_id, 10) === deliverableId)
                    .length;
                if (alreadyLoaded >= nextPage * 5) {
                    this.$set(this.projectSubgroupPages, subGroupKey, nextPage);
                    return;
                }

                const response = await this.$store.dispatch('fetchGroupedAlerts', {
                    group_type: 'project',
                    group_id: projectId,
                    deliverable_group_id: deliverableId,
                    page: nextPage,
                    per_page: 5,
                    query: this.currentFilters.query,
                    status: this.currentFilters.status
                });

                const currentData = this.groupedAlertsData[projectGroupKey] || { alerts: [], page: 1 };
                const existingIds = new Set((currentData.alerts || []).map(a => a.id));
                const newAlerts = (response && response.data) ? response.data.filter(a => !existingIds.has(a.id)) : [];

                if (newAlerts.length) {
                    this.$set(this.groupedAlertsData, projectGroupKey, {
                        alerts: [...(currentData.alerts || []), ...newAlerts],
                        page: currentData.page || 1,
                        total: currentData.total || (this.getGroupTotal(projectGroupKey) || (currentData.alerts || []).length)
                    });
                }

                this.$set(this.projectSubgroupPages, subGroupKey, response && response.current_page ? response.current_page : nextPage);
                if (response && response.has_more === false) {
                    this.$set(this.projectSubgroupHasMore, subGroupKey, false);
                }

                // Keep subgroup total in sync with API (unread is maintained by local updates)
                const totals = this.userAlerts && this.userAlerts.subgroupTotals ? this.userAlerts.subgroupTotals : null;
                if (totals && totals[projectGroupKey] && totals[projectGroupKey][String(deliverableId)]) {
                    this.$set(this.userAlerts.subgroupTotals[projectGroupKey][String(deliverableId)], 'total', response.total);
                }
            } catch (e) {
                console.error('Failed to load more subgroup alerts:', e);
            } finally {
                this.$set(this.projectSubgroupLoading, subGroupKey, false);
            }
        },
        /**
         * Get total count for a group - returns total from API if available
         */
        getGroupTotal(groupKey, fallbackCount = null) {
            const totals = this.userAlerts.groupTotals || {};
            const groupTotalMeta = totals[groupKey];

            if (typeof groupTotalMeta === 'object' && groupTotalMeta !== null && typeof groupTotalMeta.total !== 'undefined') {
                return groupTotalMeta.total;
            }

            if (this.groupedAlertsData[groupKey] && this.groupedAlertsData[groupKey].total) {
                return this.groupedAlertsData[groupKey].total;
            }
            // Fall back to provided count or current loaded count
            if (fallbackCount !== null) return fallbackCount;
            return this.getGroupAlerts(groupKey).length;
        },
        getGroupUnreadTotal(groupKey) {
            const totals = this.userAlerts.groupTotals || {};
            const groupTotalMeta = totals[groupKey];

            if (typeof groupTotalMeta === 'object' && groupTotalMeta !== null && typeof groupTotalMeta.unread !== 'undefined') {
                return groupTotalMeta.unread;
            }

            // Fallback to counting loaded alerts only (may be lower when paginated)
            return this.countUnread(this.getGroupAlerts(groupKey));
        },
        countUnread(alerts) {
            return (alerts || []).filter(alert => alert.status === 0).length;
        },
        getProjectGroupDeliverableCount(projectGroupKey) {
            const totals = (this.userAlerts && this.userAlerts.subgroupTotals) ? this.userAlerts.subgroupTotals : {};
            const subTotals = totals ? totals[projectGroupKey] : null;
            if (subTotals && typeof subTotals === 'object') {
                return Object.keys(subTotals).filter((key) => {
                    const id = parseInt(key, 10);
                    return !!(id && id > 0);
                }).length;
            }

            const alerts = this.getGroupAlerts(projectGroupKey) || [];
            const ids = new Set();
            alerts.forEach((alert) => {
                const id = alert && alert.deliverable_group_id ? parseInt(alert.deliverable_group_id, 10) : null;
                if (id && id > 0) ids.add(String(id));
            });
            return ids.size;
        },
        getCollapseTotalCount(groupKey) {
            const total = this.getGroupTotal(groupKey);
            if (this.currentFilters.group_by === 'deliverable') {
                return Math.max(total - 1, 0);
            }
            return total;
        },
        getCollapseUnreadTotal(groupKey) {
            const unread = this.getGroupUnreadTotal(groupKey);
            if (this.currentFilters.group_by === 'deliverable') {
                const first = (this.getGroupAlerts(groupKey) || [])[0];
                const subtract = first && first.status === 0 ? 1 : 0;
                return Math.max(unread - subtract, 0);
            }
            return unread;
        },
        getGroupMeta(groupKey) {
            const totals = (this.userAlerts && this.userAlerts.groupTotals) ? this.userAlerts.groupTotals : {};
            const direct = totals[groupKey];
            if (typeof direct === 'object' && direct !== null) {
                return direct;
            }
        },
        getGroupDisplayTitle(groupKey) {
            const meta = this.getGroupMeta(groupKey);
            return (meta && meta.title) ? meta.title : groupKey;
        },
        getMarkAllProjectSectionTooltip(projectGroupKey) {
            if (!this.projectSectionHasUnread(projectGroupKey)) {
                return 'Read';
            }
            return `Mark all ${this.getGroupDisplayTitle(projectGroupKey)} notifications as read`;
        },
        getMarkAllDeliverableSubgroupTooltip(subGroup) {
            if (!subGroup || subGroup.unread === 0) {
                return 'Read';
            }
            const title = subGroup.title || 'deliverable';
            return `Mark all \"${title}\" notifications as read`;
        },

        goToDetailPage(groupKey) {
            if (this.currentFilters.group_by === 'deliverable') {
                const meta = this.getGroupMeta(groupKey);
                if (meta && meta.deleted) {
                    return;
                }
                if (meta && meta.project_deleted) {
                    return;
                }
                const deliverableId = groupKey.replace('deliverable-', '');
                const parsedDeliverableId = parseInt(deliverableId, 10);
                const projectId = meta && meta.project_id ? parseInt(meta.project_id, 10) : null;
                if (!parsedDeliverableId) {
                    return;
                }

                const isMediaCall = !!meta?.is_media_call;

                // Media Calls are handled on their own page (not inside a project page/modal flow)
                if (isMediaCall) {
                    const query = {
                        openDeliverable: parsedDeliverableId,
                        templateSlug: 'media-call'
                    };
                    this.$router.push({ path: '/media-calls', query }).catch(() => {});
                    return;
                }

                if (!projectId) {
                    return;
                }
                this.getProjectNumberFromId(projectId).then((projectNumber) => {
                    if (!projectNumber) return;
                    this.navigateToProjectInPlace(projectNumber, {
                        openDeliverable: parsedDeliverableId,
                    });
                }).catch(() => {});
            } else if (this.currentFilters.group_by === 'project') {
                const projectId = groupKey.replace('project-', '');
                this.goToProject(projectId);
            }
        },
        canOpenDeliverableGroup(groupKey) {
            const meta = this.getGroupMeta(groupKey);
            if (!meta || meta.deleted || meta.project_deleted) {
                return false;
            }

            if (meta.is_media_call) {
                return true;
            }

            return !!meta.project_id;
        },
        handleFilterChange(filters) {
            const query = this.getQueryFromLocation();
            const hasRouteIntent = !!(query.group_by || query.expandGroupKey || query.focusAlertId || query.page);
            const nextFilters = { ...filters };

            if (hasRouteIntent && !this.routeIntentConsumed) {
                // if (query.group_by && ['date', 'deliverable', 'project', 'none'].includes(query.group_by)) {
                //     nextFilters.group_by = query.group_by;
                // }
                this.pendingExpandGroupKey = query.expandGroupKey || this.pendingExpandGroupKey;
                this.pendingFocusAlertId = query.focusAlertId || this.pendingFocusAlertId;
                this.routeIntentConsumed = true;
            }


            const routePage = this.getRoutePage(query.page);
            let pageToFetch = 1;
            if (routePage) {
                pageToFetch = routePage;
            } else if (!this.notificationPageRestored) {
                pageToFetch = this.notificationPage || 1;
            } else {
                this.notificationPage = 1;
            }

            this.currentFilters = { ...nextFilters };
            this.updateNotificationDocumentTitle(this.currentFilters.group_by);
            this.pushHistoryState({
                group_by: this.currentFilters.group_by,
                page: pageToFetch
            });
            this.notificationPageRestored = true;
            this.fetchAlertsWithFilters(pageToFetch).then(() => this.applyPendingExpansion()); // Reset to page 1 when filters change
        },
        getNotificationGroupTitle(groupBy) {
            switch (groupBy) {
                case 'date':
                    return 'Notifications By Date';
                case 'deliverable':
                    return 'Notifications By Deliverable';
                case 'project':
                    return 'Notifications By Project';
                default:
                    return 'Your Messages';
            }
        },
        updateNotificationDocumentTitle(groupBy) {
            const label = this.getNotificationGroupTitle(groupBy);
            const appName = process.env.MIX_APP_NAME || '';
            const query = this.getQueryFromLocation();
            const routePage = this.getRoutePage(query.page);
            const page = routePage || this.notificationPage || 1;
            const pageSuffix = ` - Page ${page}`;
            const baseTitle = appName ? `${appName} - ${label}${pageSuffix}` : `${label}${pageSuffix}`;
            const currentTitlePrefix = document.title.match(/^\(\d+\)\s*/);
            document.title = currentTitlePrefix ? currentTitlePrefix[0] + baseTitle : baseTitle;
        },
        getRoutePage(value) {
            const parsed = parseInt(value, 10);
            return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
        },
        getQueryFromLocation() {
            const params = new URLSearchParams(window.location.search || '');
            const query = {};
            for (const [key, value] of params.entries()) {
                query[key] = value;
            }
            return query;
        },
        pushHistoryState({ group_by, page, focusAlertId, expandGroupKey } = {}) {
            const currentQuery = this.getQueryFromLocation();
            const nextGroupBy = group_by || this.currentFilters.group_by || 'date';
            const nextPage = Number.isFinite(page) && page > 0 ? page : (this.notificationPage || 1);

            const nextQuery = {
                ...currentQuery,
                group_by: nextGroupBy,
                page: String(nextPage)
            };
            if (typeof focusAlertId !== 'undefined' && focusAlertId !== null) {
                nextQuery.focusAlertId = String(focusAlertId);
            } else if (typeof nextQuery.focusAlertId !== 'undefined') {
                delete nextQuery.focusAlertId;
            }
            if (typeof expandGroupKey !== 'undefined' && expandGroupKey !== null) {
                nextQuery.expandGroupKey = String(expandGroupKey);
            } else if (typeof nextQuery.expandGroupKey !== 'undefined') {
                delete nextQuery.expandGroupKey;
            }

            const sameGroupBy = String(currentQuery.group_by || '') === String(nextQuery.group_by || '');
            const samePage = String(currentQuery.page || '') === String(nextQuery.page || '');
            const sameFocus = String(currentQuery.focusAlertId || '') === String(nextQuery.focusAlertId || '');
            const sameExpand = String(currentQuery.expandGroupKey || '') === String(nextQuery.expandGroupKey || '');
            if (sameGroupBy && samePage && sameFocus && sameExpand) return;

            const qs = new URLSearchParams(nextQuery).toString();
            const hash = window.location.hash || '';
            const url = `${window.location.pathname}${qs ? `?${qs}` : ''}${hash}`;
            history.pushState({}, null, url);
            this.updateNotificationDocumentTitle(nextGroupBy);
        },
        processMessage(message) {
            if (!message) return '';
            message = this.$options.filters.striphtml(message);
            if (message.length > 120) {
                return message.substring(0, 120) + '...';
            }
            return message;
        },
        getUnreadGlobalAlerts() {
            if (this.userAlerts && Array.isArray(this.userAlerts.unreadGlobalAlerts)) {
                return this.userAlerts.unreadGlobalAlerts;
            }
            return (this.userAlerts && this.userAlerts.data ? this.userAlerts.data : [])
                .filter(alert => this.isGlobalAlertType(alert) && alert.status == 0);
        },
        isGlobalAlertType(alert) {
            if (!alert) return false;
            const slug = alert.alert_type_slug || alert.alert_type;
            if (slug === 'general' || slug === 'system-update') return true;
            return false;
        },
        getDateGroupAlerts(group) {
            // Keep global alerts in the normal list only when they're already read.
            return (group || []).filter(alert => !(this.isGlobalAlertType(alert) && alert.status == 0));
        },
        markSingleAlertRead(alert) {
            this.markAlertReadOnly(alert);
        },
        markAlertReadOnly(alert, groupKey = null, opts = {}) {
            if (!alert || alert.status != 0) return;
            this.$store.dispatch('makeAlertRead', { alert, silent: true }).then(() => {
                this.updateLocalAlertStatus(alert.id, groupKey, opts);
            });
        },
        getDeliverableIconSrc(status) {
            return status === 0
                ? require('@/csmworkflow/img/project-deliverable-white.svg')
                : require('@/csmworkflow/img/project-deliverable.svg');
        },
        getDeliverableSubgroupHeaderIcon(subGroup) {
            const unread = subGroup && typeof subGroup.unread !== 'undefined' ? subGroup.unread : 0;
            return unread === 0
                ? require('@/csmworkflow/img/project-deliverable.svg')
                : require('@/csmworkflow/img/project-deliverable-white.svg');
        },
        getProjectIconColor(status) {
            return status === 0 ? '#ffffff' : '#000000';
        },
        onChangePage(data) {
            this.notificationPage = data;
            this.pushHistoryState({
                group_by: this.currentFilters.group_by,
                page: data
            });
            this.scrollToTop();
            this.fetchAlertsWithFilters(data);
        },
        scrollToTop() {
            const container = document.getElementById('content');
            if (container) {
                if (typeof container.scrollTo === 'function') {
                    container.scrollTo({ top: 0, behavior: 'smooth' });
                } else {
                    container.scrollTop = 0;
                }
                return;
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        deleteAlert(alertId) {
            this.$store.dispatch('deleteAlert', { alertId });
        },
        makeAllFilteredAlertsRead() {
            // Mark all alerts matching current filters (all pages)
            this.runningTask = true;
            this.$store.dispatch('makeAlertsRead', {
                markAllFiltered: true,
                filters: this.currentFilters
            })
                .then(() => {
                    this.runningTask = false;
                    this.fetchAlertsWithFilters();
                    toast.success('Marked all filtered notifications as read.');
                })
                .catch(() => {
                    this.runningTask = false;
                });
        },
        makeGroupAlertsRead(target) {
            // Support marking an entire grouped bucket (across pages) or a provided list
            const isGroupKey = typeof target === 'string';
            const groupKey = isGroupKey ? target : null;
            const groupAlerts = isGroupKey ? this.getGroupAlerts(groupKey) : target;

            if (!groupAlerts || groupAlerts.length === 0) {
                return;
            }

            // If we're in grouped view, mark all alerts in that group across pages via backend filters
            if (isGroupKey && ['deliverable', 'project'].includes(this.currentFilters.group_by)) {
                const groupType = this.currentFilters.group_by;
                const groupId = groupKey.replace(`${groupType}-`, '');

                this.$store.dispatch('makeAlertsRead', {
                    markGroupAll: true,
                    group_type: groupType,
                    group_id: groupId,
                    filters: this.currentFilters
                })
                    .then(() => {
                    this.fetchAlertsWithFilters().then(() => {
                        this.maybeCollapseGroup(groupKey);
                    });
                        toast.success('Marked all notifications in this group as read.');
                    })
                    .catch(() => {
                        // Error handling
                    });
                return;
            }

            // Fallback: mark the provided alerts (non-grouped/date view)
            const alertIds = groupAlerts
                .filter(alert => alert.status === 0)
                .map(alert => alert.id);

            if (alertIds.length === 0) {
                return;
            }

            this.$store.dispatch('makeAlertsRead', { alertIds })
                .then(() => {
                    this.fetchAlertsWithFilters();
                    toast.success(`Marked ${alertIds.length} notification(s) as read.`);
                })
                .catch(() => {
                    // Error handling
                });
        },
        markAllProjectLevelNotifsRead(projectGroupKey) {
            const projectId = projectGroupKey ? parseInt(String(projectGroupKey).replace('project-', ''), 10) : null;
            if (!projectId || projectId <= 0) {
                return;
            }

            // No-op when there's nothing unread to mark.
            if (!this.projectSectionHasUnread(projectGroupKey)) {
                return;
            }

            this.$store.dispatch('makeAlertsRead', {
                markGroupAll: true,
                group_type: 'project',
                group_id: projectId,
                project_section_only: true,
                filters: this.currentFilters
            }).then(() => {
                this.fetchAlertsWithFilters().then(() => {
                    this.applyPendingExpansion();
                    this.maybeCollapseGroup(projectGroupKey);
                });
                toast.success('Marked all project notifications as read.');
            }).catch(() => {});
        },
        markAllDeliverableSubgroupNotifsRead(projectGroupKey, deliverableId, unreadCount = null) {
            const projectId = projectGroupKey ? parseInt(String(projectGroupKey).replace('project-', ''), 10) : null;
            const parsedDeliverableId = parseInt(deliverableId, 10);
            if (!projectId || projectId <= 0 || !parsedDeliverableId) return;
            if (unreadCount !== null && unreadCount <= 0) return;

            this.$store.dispatch('makeAlertsRead', {
                markGroupAll: true,
                group_type: 'project',
                group_id: projectId,
                deliverable_group_id: parsedDeliverableId,
                filters: this.currentFilters
            }).then(() => {
                this.fetchAlertsWithFilters().then(() => {
                    this.applyPendingExpansion();
                    this.maybeCollapseGroup(projectGroupKey);
                });
            }).catch(() => {});
        },
        openDeliverableFromProjectSubgroup(projectGroupKey, deliverableId) {
            const projectId = projectGroupKey ? parseInt(String(projectGroupKey).replace('project-', ''), 10) : null;
            const parsedDeliverableId = parseInt(deliverableId, 10);
            if (!projectId || !parsedDeliverableId || parsedDeliverableId <= 0) return;

            const meta = this.getProjectSubgroupMeta(projectGroupKey, parsedDeliverableId);
            if (meta && meta.deleted) {
                toast.error("This deliverable has been deleted and can no longer be opened.");
                return;
            }

            this.getProjectNumberFromId(projectId).then((projectNumber) => {
                if (!projectNumber) return;
                this.navigateToProjectInPlace(projectNumber, { openDeliverable: parsedDeliverableId });
            }).catch(() => {});
        },
        groupHasUnread(groupKey) {
            return this.hasUnreadInGroup(this.getGroupAlerts(groupKey));
        },
        showGroupMarkButton(groupKey) {
            const alerts = this.getGroupAlerts(groupKey) || [];
            return alerts.length >= 0 && this.groupHasUnread(groupKey);
        },
        hasUnreadInGroup(group) {
            return group && group.some(alert => alert.status === 0);
        },
        updateLocalAlertStatus(alertId, providedGroupKey = null, opts = {}) {
            if (!this.userAlerts || !this.userAlerts.data) {
                return;
            }

            let unreadDecremented = false;
            let lastGroupKey = null;

            // Update unread global alerts list (if provided by API)
            if (Array.isArray(this.userAlerts.unreadGlobalAlerts)) {
                const globalIdx = this.userAlerts.unreadGlobalAlerts.findIndex(a => a.id === alertId);
                if (globalIdx !== -1) {
                    this.$set(this.userAlerts.unreadGlobalAlerts[globalIdx], 'status', 1);
                    this.userAlerts.unreadGlobalAlerts.splice(globalIdx, 1);
                    if (typeof this.userAlerts.unreadGlobalAlertsCount !== 'undefined') {
                        this.userAlerts.unreadGlobalAlertsCount = Math.max((this.userAlerts.unreadGlobalAlertsCount || 0) - 1, 0);
                    }
                }
            }

            // Update main alerts list
            const alertIdx = this.userAlerts.data.findIndex(a => a.id === alertId);
            if (alertIdx !== -1 && this.userAlerts.data[alertIdx].status === 0) {
                this.$set(this.userAlerts.data[alertIdx], 'status', 1);
                const groupKey = providedGroupKey || this.getAlertGroupKey(this.userAlerts.data[alertIdx]);
                if (groupKey) {
                    this.decrementGroupUnread(groupKey);
                    if (groupKey.startsWith('project-') && this.userAlerts.data[alertIdx].deliverable_group_id) {
                        this.decrementProjectSubgroupUnread(groupKey, this.userAlerts.data[alertIdx].deliverable_group_id);
                    }
                    unreadDecremented = true;
                    lastGroupKey = groupKey;
                }
            }

            // Update grouped cache (deliverable/project load-more buckets)
            Object.keys(this.groupedAlertsData || {}).forEach(groupKey => {
                const groupData = this.groupedAlertsData[groupKey];
                if (!groupData || !groupData.alerts) {
                    return;
                }
                const groupAlertIdx = groupData.alerts.findIndex(a => a.id === alertId);
                if (groupAlertIdx !== -1 && groupData.alerts[groupAlertIdx].status === 0) {
                    this.$set(this.groupedAlertsData[groupKey].alerts[groupAlertIdx], 'status', 1);
                    if (!unreadDecremented) {
                        this.decrementGroupUnread(groupKey);
                        if (groupKey.startsWith('project-') && groupData.alerts[groupAlertIdx].deliverable_group_id) {
                            this.decrementProjectSubgroupUnread(groupKey, groupData.alerts[groupAlertIdx].deliverable_group_id);
                        }
                        unreadDecremented = true;
                    }
                    lastGroupKey = groupKey;
                    if (opts.isTopRow && providedGroupKey === groupKey && groupAlertIdx === 0) {
                        this.$set(this.groupedAlertsData[groupKey].alerts[0], 'status', 1);
                    }
                }
            });

            if (lastGroupKey) {
                this.maybeCollapseGroup(lastGroupKey);
            }
        },
        maybeCollapseGroup(groupKey) {
            if (!groupKey || !['deliverable', 'project'].includes(this.currentFilters.group_by)) {
                return;
            }
            const unread = this.getGroupUnreadTotal(groupKey);
            if (unread !== 0) {
                return;
            }
            const collapseId = `notification-group-collapse-${groupKey}`;
            const isExpanded = () => {
                const known = this.collapseStates[collapseId];
                if (typeof known === 'boolean') return known;
                const el = document.getElementById(collapseId);
                return !!(el && el.classList && el.classList.contains('show'));
            };
            if (isExpanded()) {
                this.$root.$emit('bv::toggle::collapse', collapseId);
                this.$set(this.collapseStates, collapseId, false);
            }
        },
        getAlertGroupKey(alert) {
            if (!alert || !this.currentFilters || !this.currentFilters.group_by) {
                return null;
            }
            if (this.currentFilters.group_by === 'deliverable' && alert.grouped_model === 'deliverable' && alert.grouped_model_id) {
                const deliverableGroupId = alert.deliverable_group_id || alert.grouped_model_id;
                return `deliverable-${deliverableGroupId}`;
            }
            if (this.currentFilters.group_by === 'project' && alert.grouped_model === 'project' && alert.grouped_model_id) {
                return `project-${alert.grouped_model_id}`;
            }
            return null;
        },
        decrementGroupUnread(groupKey) {
            if (!this.userAlerts || !this.userAlerts.groupTotals || !this.userAlerts.groupTotals[groupKey]) {
                return;
            }
            const meta = this.userAlerts.groupTotals[groupKey];
            if (typeof meta === 'object' && meta !== null && typeof meta.unread !== 'undefined') {
                const next = Math.max((meta.unread || 0) - 1, 0);
                this.$set(this.userAlerts.groupTotals[groupKey], 'unread', next);
            }
        },
        decrementProjectSubgroupUnread(projectGroupKey, deliverableGroupId) {
            const did = parseInt(deliverableGroupId, 10);
            if (!did || !this.userAlerts || !this.userAlerts.subgroupTotals || !this.userAlerts.subgroupTotals[projectGroupKey]) {
                return;
            }
            const meta = this.userAlerts.subgroupTotals[projectGroupKey][String(did)];
            if (typeof meta === 'object' && meta !== null && typeof meta.unread !== 'undefined') {
                const next = Math.max((meta.unread || 0) - 1, 0);
                this.$set(this.userAlerts.subgroupTotals[projectGroupKey][String(did)], 'unread', next);
            }
        },
        navigateToProjectInPlace(projectNumber, query = {}) {
            if (!projectNumber) return;
            const cleaned = Object.keys(query).reduce((acc, key) => {
                const value = query[key];
                if (value === undefined || value === null || value === '') return acc;
                acc[key] = String(value);
                return acc;
            }, {});

            if (this.$router) {
                this.$router.push({ path: `/project/${projectNumber}`, query: cleaned }).then(() => {
                    this.markHistoryFromNotifications();
                }).catch(() => {});
                return;
            }

            const qs = new URLSearchParams(cleaned).toString();
            const suffix = qs ? `?${qs}` : '';
            window.location.href = `${window.location.origin}/project/${projectNumber}${suffix}`;
        },
        setAlert(alert, groupKey = null, opts = {}) {
            console.log('Set alert:', alert);
            const chatModels = ['chat', 'project-chat', 'deliverable-chat'];
            this.alertTitle = alert.title;
            this.alertDetail = alert.message;
            this.alertSender = alert.sender;
            this.alertTime = alert.created_at;
            const isChat =  chatModels.includes(alert.alert_model)? 1 : 0;
            this.notificationReturnUrl = window.location.href;
            this.urlSyncEnabled = true;
            const resolvedGroupKey = groupKey || this.getAlertGroupKey(alert);
            this.notificationReturnUrl = this.buildNotificationReturnUrl(alert, resolvedGroupKey);
            if (alert && alert.id) {
                this.pushHistoryState({
                    group_by: this.currentFilters.group_by,
                    page: this.notificationPage || 1,
                    focusAlertId: alert.id,
                    expandGroupKey: resolvedGroupKey
                });
            }

            if (alert.status == 0) {
                this.$store.dispatch('makeAlertRead', { alert, silent: true }).then(() => {
                    this.updateLocalAlertStatus(alert.id, groupKey, opts);
                });
            }

            console.log('Alert model:', alert.alert_model, 'Grouped model:', alert.grouped_model, "Alert", alert);

            const isDeliverableAlert = (alert.alert_model === "deliverable" || alert.grouped_model === "deliverable") && alert.alert_model !== "task";

            if (isDeliverableAlert) {
                const deliverableId = alert.grouped_model === "deliverable" ? alert.grouped_model_id : alert.model_id;

                this.$store.dispatch("getDeliverableDetail", { deliverableId })
                    .then(() => {
                        const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
                        const projectId = this.deliverableDetail.project_id?.id || this.deliverableDetail.project_id || this.deliverableDetail.project?.id;

                        // Media Calls are handled on their own page; for chat alerts open the Media Calls page and the chat tab
                        if (isChat && deliverableTemplateSlug === "media-call") {
                            const query = {
                                openDeliverable: deliverableId,
                                templateSlug: deliverableTemplateSlug,
                                isChat: isChat ? '1' : undefined
                            };
                            this.$router.push({ path: '/media-calls', query }).then(() => {
                                this.markHistoryFromNotifications();
                            }).catch(() => {});
                            return;
                        }

                        if (projectId) {
                            this.getProjectNumberFromId(projectId).then((projectNumber) => {
                                if (projectNumber) {
                                    this.navigateToProjectInPlace(projectNumber, {
                                        openDeliverable: deliverableId,
                                        templateSlug: deliverableTemplateSlug,
                                        openChildTask: deliverableTemplateSlug === "social-media" ? '1' : undefined,
                                        isChat: isChat ? '1' : undefined
                                    });
                                }
                            }).catch(() => {});
                            return;
                        }

                        // Fallback: resolve project number via deliverable id (covers cases where project_id isn't present)
                        this.$store.dispatch("getProjectNumberFromDeliverableId", deliverableId)
                            .then((data) => {
                                if (data && data.project_number) {
                                    this.navigateToProjectInPlace(data.project_number, {
                                        openDeliverable: deliverableId,
                                        templateSlug: deliverableTemplateSlug,
                                        openChildTask: deliverableTemplateSlug === "social-media" ? '1' : undefined,
                                        isChat: isChat ? '1' : undefined
                                    });
                                }
                            })
                            .catch(() => {});
                    });
            } else if (alert.alert_model == "task") {
                console.log('Alert is for task, fetching deliverable detail by task ID');
                let taskId = alert.model_id;
                this.$store.dispatch("getDeliverableDetailByTask", { taskId })
                    .then(() => {
                        console.log('Fetched deliverable detail for task:', this.deliverableDetail);
                        const deliverableId = this.deliverableDetail?.id;
                        const projectId = this.deliverableDetail.project_id?.id || this.deliverableDetail.project_id || this.deliverableDetail.project?.id;
                        const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
                        const isChildSocialTask = deliverableTemplateSlug === "social-media";

                        // Media Calls are handled on their own page (no project route); include task highlight.
                        if (deliverableTemplateSlug === "media-call") {
                            const query = {
                                openDeliverable: deliverableId,
                                templateSlug: deliverableTemplateSlug,
                                highlightTask: taskId,
                            };
                            this.$router.push({ path: '/media-calls', query }).then(() => {
                                this.markHistoryFromNotifications();
                            }).catch(() => {});
                            return;
                        }

                        if (projectId) {
                            this.getProjectNumberFromId(projectId).then((projectNumber) => {
                                if (projectNumber) {
                                    this.navigateToProjectInPlace(projectNumber, {
                                        openDeliverable: deliverableId,
                                        highlightTask: taskId,
                                        openChildTask: isChildSocialTask ? '1' : undefined,
                                    });
                                }
                            }).catch(() => {});
                            return;
                        }

                        if (deliverableId) {
                            this.$store.dispatch("getProjectNumberFromDeliverableId", deliverableId)
                                .then((data) => {
                                    if (data && data.project_number) {
                                    this.navigateToProjectInPlace(data.project_number, {
                                        openDeliverable: deliverableId,
                                        highlightTask: taskId,
                                        openChildTask: isChildSocialTask ? '1' : undefined,
                                    });
                                }
                            })
                                .catch(() => {});
                        }
                    });
            } else if (alert.alert_model == "project" || alert.grouped_model == "project") {
                let projectId = alert.model_id;
                if (alert.grouped_model == "project") {
                    projectId = alert.grouped_model_id;
                }
                this.goToProject(projectId);
            } else {
                this.$bvModal.show("userGlobalAlertDetail");
            }
        },

        goToProject(projectId) {
            this.setDataLoading(true);
            this.getProjectNumberFromId(projectId).then((projectNumber) => {
                if (projectNumber) {
                    this.fetchProjectDeliverableById(projectNumber).then(() => {
                        this.setDataLoading(false);
                        const isNumber = !isNaN(Number(projectNumber));
                        if (isNumber) {
                            if (this.$router) {
                                this.$router.push({ path: `/project/${projectNumber}` }).then(() => {
                                    this.markHistoryFromNotifications();
                                }).catch(() => {});
                                return;
                            }
                            window.location.href = `${window.location.origin}/project/${projectNumber}`;
                        }
                    });
                }
            }).catch(() => {
                this.setDataLoading(false);
            });
        },

        getLocalAlertTime(time) {
            const alertTime = this.$moment.utc(time);
            alertTime.local();
            return alertTime.format('MMM Do, hh:mm a');
        },

        // Deliverable modal related
        editDeliverableModalHidden() {
            this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
        },
        editSocialModalHidden() {
            this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
        },
        editOrganicSocialModalPlanHidden() {
            this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
        },
        pushRoute() {
            if (this.$router.currentRoute.path.indexOf('deliverable/') == -1) {
                history.pushState(
                    {},
                    null,
                    'deliverable/' + encodeURIComponent(this.deliverableDetail.id) + '/' + encodeURIComponent(this.deliverableDetail.slug)
                )
            }
        },
        removeRoute() {
            if (this.$router.currentRoute.path.indexOf('deliverable/') != -1) {
                this.$router.push({ name: 'dashboard' });
            } else {
                history.pushState(
                    {},
                    null,
                    this.$router.currentRoute.path
                );
                //this.$router.push(this.$router.currentRoute.path).catch(err => {console.log(err)});
            }
        },
    }
}
</script>

<style scoped>
.group-header {
    font-size: 1.2rem;
    font-weight: 600;
    color: #495057;
    border-bottom: 2px solid #dee2e6;
    padding-bottom: 0.5rem;
    margin-bottom: 1rem;
    margin-top: 0;
    padding-left: 0.5rem;
}

.alert-item {
    display: flex;
    flex-direction: column;
}

.notification-group-block {
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 1.5rem;
    position: relative;
}

.dbox-wrapper {
    min-height: 100px;
}

.dbox-left-side {
    background-color: #f8f9fa;
}

.dbox-right-side {
    display: flex;
    align-items: stretch;
}

.top-row {
    display: flex;
    align-items: center;
    padding: 0rem .5rem;
    background-color: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    height: 100px;
    position: relative;
}

.top-row .data-items.ml-auto {
    height: 100%;
    width: 120px;
    margin-right: 0 !important;
}
.top-row .data-items.ml-auto button{
    position: absolute;
    top: 10px;
    right: 10px;
}

.group-title {
    width: 250px;
    flex-shrink: 0;
}

.group-header-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #495057;
    padding-left: 0.5rem;
}

.notification-preview {
    padding: 10px 0 0 10px;
    display: flex;
    align-items: flex-start;

    .info-bubbles {
        margin-top: 0;
    }

    .initials {
        width: 48px;
        height: 48px;
        line-height: 48px;
        font-size: 16px!important;
    }
}

.notification-preview.unread-notification {
    background-color: #e7f3ff !important;
}

.no-grouping-list{
   li{
     margin-left: -15px;
    }
}

.global-alerts-section {
    background: #ffffff;
    overflow: hidden;
}

.global-alerts-section .no-grouping-list li {
    margin-left: 0;
}

.global-alerts-section .notification-info-wrapper {
    align-items: center;
}

.global-alerts-section .notification-info-wrapper .details {
    flex: 1 1 auto;
    margin-bottom: 0;
}

/* Single column layout - one notification per row */
.notification-list-single-column {
    padding: 0;
    margin-left: 0!important;
    width: 100%;
}

.placeholder-n{
    width: 250px;
}
.notification-info-wrapper{
    flex: 1;
    padding: 0 0 0 10px;
    display: flex;
}

.notification-single-row{
display: flex;
    align-items: center;
        border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.2s;
}

.no-group-alert-item.notification-single-row {

    width: 100% !important;
    min-height: auto !important;
    padding: 10px .5rem 0px !important;

}

.group-alert-item.notification-single-row {

    width: 100% !important;
    margin: 0 0 .5rem 0 !important;
    min-height: auto !important;
    padding: 10px .5rem 0px !important;
}

.notification-single-row:last-child {
    border-bottom: none;
}

.notification-single-row:hover {
    background-color: #f8f9fa;
}
.notification-preview.read-notification .initials{
    background-color: rgba(191, 191, 191, 0.25);
}

.notification-preview.read-notification .fw-bold{
    font-weight: unset !important;
}

.notification-single-row .message-img {
    flex-shrink: 0;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1rem;
}

.notification-single-row .message-info {
    flex: 1;
    min-width: 0;
    cursor: pointer;
}

.notification-single-row .message-detail {
    margin-bottom: 0.25rem;
}

.notification-single-row .message-detail h4 {
    font-size: 1rem;
    font-weight: 600;
    margin: 0 0 0.25rem 0;
    color: #212529;
}

.notification-single-row .message-detail span {
    font-size: 0.875rem;
    color: #6c757d;
    display: block;
}

.notification-single-row .message-time {
    font-size: 0.75rem;
    color: #adb5bd;
    margin-top: 0.25rem;
}

.notification-single-row .message-remove {
    flex-shrink: 0;
    margin-left: 1rem;
}

.notification-single-row .message-remove a {
    color: #dc3545;
    cursor: pointer;
    font-size: 1.1rem;
    padding: 0.5rem;
    display: inline-block;
}

.notification-single-row .message-remove a:hover {
    color: #c82333;
}

.group-header-row {
    position: relative;
}

.group-header-row .btn {
    position: absolute;
    top: 10px;
    right: 10px;
}

.task-deliverable {
    font-size: 0.8rem;
    color: #6c757d;
}

.load-more-btn {
    border-color: #6c757d;
    color: #6c757d;
    background-color: transparent;
}

.load-more-btn:hover {
    background-color: #f8f9fa;
    border-color: #6c757d;
    color: #495057;
}

.load-more-btn:disabled {
    border-color: #adb5bd;
    color: #adb5bd;
}

.notification-icon-wrapper {
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: -10px 10px 0 0;
}

.notification-icon-fa {
    font-size: 18px;
    color: #000;
}
.project-subgroup-wrapper:first-child{
    margin: 10px 0;
}
.project-subgroup-wrapper{
    padding: 0 10px 0 0;
    margin: 0 0 10px 0;
}
.project-subgroup-wrapper .group-header-title{
    padding-left: 3.5rem;
}
.project-subgroup-wrapper .notification-info-wrapper{
    padding: 0 0 0 58px;
}

.project-section-list {
    margin: 0 0 12px 0;
}

.project-section-list .notification-info-wrapper {
    padding: 0 0 0 58px;
}

.project-section-header{
    height: 84px;
    display: flex;
    align-items: center;
}

.project-section-header .notification-info-wrapper {
    padding: 0 0 0 10px;
}
.project-section-header .notification-icon-wrapper{
    margin: -8px 0 0 0!important;
}

.project-section-header .notification-info-wrapper .alert__name{
    font-weight: 600;
    padding: 0 0 0 10px;
}

.project-section-list + .project-subgroup-wrapper {
    margin-top: 12px;
}

.deliverable-subgroup-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 0;
}

.deliverable-subgroup-title-icon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
}
.deliverable-subgroup-preview{
    align-items: center;
    padding: 0 0 0 10px!important;
}
</style>
